/**
 * English → Dutch phrase map.
 * Keys must match the original English UI string exactly.
 * Use {name} placeholders for interpolated values.
 */
const nl = {
  // ── Common ──────────────────────────────────────────────
  'Loading...': 'Laden...',
  'Loading': 'Laden',
  'Save': 'Opslaan',
  'Saving...': 'Opslaan...',
  'Cancel': 'Annuleren',
  'Delete': 'Verwijderen',
  'Edit': 'Bewerken',
  'Update': 'Bijwerken',
  'Create': 'Aanmaken',
  'Add': 'Toevoegen',
  'Remove': 'Verwijderen',
  'Search': 'Zoeken',
  'Search...': 'Zoeken...',
  'Filter': 'Filteren',
  'Filters': 'Filters',
  'Clear': 'Wissen',
  'Refresh': 'Vernieuwen',
  '🔄 Refresh': '🔄 Vernieuwen',
  'Close': 'Sluiten',
  'Confirm': 'Bevestigen',
  'Yes': 'Ja',
  'No': 'Nee',
  'All': 'Alle',
  'Actions': 'Acties',
  'Status': 'Status',
  'Status:': 'Status:',
  'Name': 'Naam',
  'Email': 'E-mail',
  'Phone': 'Telefoon',
  'Address': 'Adres',
  'Date': 'Datum',
  'Amount': 'Bedrag',
  'Total': 'Totaal',
  'Notes': 'Opmerkingen',
  'Notes:': 'Opmerkingen:',
  'Description': 'Beschrijving',
  'Type': 'Type',
  'Type *': 'Type *',
  'Type:': 'Type:',
  'Category': 'Categorie',
  'Department': 'Afdeling',
  'Position': 'Functie',
  'Salary': 'Salaris',
  'Employee': 'Werknemer',
  'Employees': 'Werknemers',
  'User': 'Gebruiker',
  'Users': 'Gebruikers',
  'Role': 'Rol',
  'Active': 'Actief',
  'Inactive': 'Inactief',
  'Pending': 'In behandeling',
  'Approved': 'Goedgekeurd',
  'Rejected': 'Afgewezen',
  'Optional': 'Optioneel',
  'Required': 'Verplicht',
  'N/A': 'n.v.t.',
  'Unknown': 'Onbekend',
  'View': 'Bekijken',
  'View Details': 'Details bekijken',
  'Download': 'Downloaden',
  'Upload': 'Uploaden',
  'Export': 'Exporteren',
  'Import': 'Importeren',
  'Back': 'Terug',
  'Next': 'Volgende',
  'Previous': 'Vorige',
  'Apply': 'Toepassen',
  'Reset': 'Resetten',
  'Select All': 'Alles selecteren',
  'Deselect All': 'Alles deselecteren',
  'None': 'Geen',
  'Other': 'Overig',
  'From': 'Van',
  'To': 'Tot',
  'Start Date': 'Startdatum',
  'Start Date *': 'Startdatum *',
  'Start Date:': 'Startdatum:',
  'End Date': 'Einddatum',
  'End Date:': 'Einddatum:',
  'Start Time': 'Starttijd',
  'End Time': 'Eindtijd',
  'Year': 'Jaar',
  'Month': 'Maand',
  'Week': 'Week',
  'Day': 'Dag',
  'Hours': 'Uren',
  'Minutes': 'Minuten',
  'Rate': 'Tarief',
  'Currency': 'Valuta',
  'Comments': 'Opmerkingen',
  'Reason': 'Reden',
  'Reason:': 'Reden:',
  'Details': 'Details',
  'Settings': 'Instellingen',
  'Security': 'Beveiliging',
  'Configuration': 'Configuratie',
  'Preview': 'Voorbeeld',
  'Test': 'Test',
  'Success': 'Geslaagd',
  'Error': 'Fout',
  'Warning': 'Waarschuwing',
  'Info': 'Info',
  'Enabled': 'Ingeschakeld',
  'Disabled': 'Uitgeschakeld',
  'On': 'Aan',
  'Off': 'Uit',
  'Yes': 'Ja',
  'No': 'Nee',
  '{status}': '{status}',
  'Just now': 'Zojuist',
  '{mins}m ago': '{mins}m geleden',
  '{hours}h ago': '{hours}u geleden',
  '{days}d ago': '{days}d geleden',
  'Saving Changes...': 'Wijzigingen opslaan...',
  '💾 Save Changes': '💾 Wijzigingen opslaan',
  'Save Changes': 'Wijzigingen opslaan',
  '💾 Save': '💾 Opslaan',
  '🔄 Saving...': '🔄 Opslaan...',
  'Processing...': 'Verwerken...',
  'Exporting...': 'Exporteren...',
  '🔄 Processing...': '🔄 Verwerken...',
  '🔄 Refreshing...': '🔄 Vernieuwen...',
  'Creating...': 'Aanmaken...',
  'Changing...': 'Wijzigen...',
  'Calculating...': 'Berekenen...',
  'Confirm & Apply': 'Bevestigen en toepassen',
  'This action cannot be undone.': 'Deze actie kan niet ongedaan worden gemaakt.',

  // ── Language ────────────────────────────────────────────
  'Language': 'Taal',
  'English': 'Engels',
  'Dutch': 'Nederlands',
  'Nederlands': 'Nederlands',
  'Choose your preferred language': 'Kies je voorkeurstaal',
  'Interface language': 'Interfacetaal',

  // ── Login ───────────────────────────────────────────────
  'Management System': 'Beheersysteem',
  'Password': 'Wachtwoord',
  'Enter your password': 'Voer je wachtwoord in',
  'Sign In': 'Inloggen',
  'Signing in...': 'Bezig met inloggen...',
  'Secure Access Only': 'Alleen beveiligde toegang',
  'Login failed': 'Inloggen mislukt',
  'Login failed. Please check your credentials.': 'Inloggen mislukt. Controleer je gegevens.',

  // ── Nav / Layout ────────────────────────────────────────
  'Dashboard': 'Dashboard',
  'Admin Panel': 'Beheerderspaneel',
  'All Employees': 'Alle werknemers',
  'Documents': 'Documenten',
  'Contracts': 'Contracten',
  'Time & Attendance': 'Tijd & aanwezigheid',
  'Attendance': 'Aanwezigheid',
  'Time Management': 'Tijdbeheer',
  'Overtime Config': 'Overurenconfiguratie',
  'Public Holidays': 'Feestdagen',
  'Payroll & Finance': 'Salaris & financiën',
  'Payroll': 'Salarisadministratie',
  'Finance': 'Financiën',
  'Tax Config': 'Belastingconfiguratie',
  'Overtime Tax': 'Overurenbelasting',
  'Benefits': 'Toeslagen',
  'Deductions': 'Inhoudingen',
  'Approvals': 'Goedkeuringen',
  'Pending Approvals': 'Openstaande goedkeuringen',
  'Payroll Consolidation': 'Salarisconsolidatie',
  'Reports': 'Rapporten',
  'Notifications': 'Meldingen',
  'Mark all as read': 'Alles als gelezen markeren',
  'No notifications yet': 'Nog geen meldingen',
  '⚙️ Notification Settings': '⚙️ Meldingsinstellingen',
  'My Profile': 'Mijn profiel',
  '🔒 Security': '🔒 Beveiliging',
  '📊 Activity Log': '📊 Activiteitenlogboek',
  'Logout': 'Uitloggen',
  'Profile': 'Profiel',

  // ── Roles ───────────────────────────────────────────────
  'super admin': 'superbeheerder',
  'hr manager': 'HR-manager',
  'finance manager': 'financieel manager',
  'operations manager': 'operationeel manager',
  'security guard': 'beveiliger',
  'Super Admin': 'Superbeheerder',
  'HR Manager': 'HR-manager',
  'Finance Manager': 'Financieel manager',
  'Operations Manager': 'Operationeel manager',
  'Security Guard': 'Beveiliger',

  // ── Statuses ────────────────────────────────────────────
  'present': 'aanwezig',
  'absent': 'afwezig',
  'late': 'te laat',
  'halfday': 'halve dag',
  'sunday': 'zondag',
  'holiday': 'feestdag',
  'sick': 'ziek',
  'vacation': 'vakantie',
  'Present': 'Aanwezig',
  'Absent': 'Afwezig',
  'Late': 'Te laat',
  'Half Day': 'Halve dag',
  'Sunday': 'Zondag',
  'Holiday': 'Feestdag',
  'Sick': 'Ziek',
  'Vacation': 'Vakantie',
  'active': 'actief',
  'inactive': 'inactief',
  'pending': 'in behandeling',
  'approved': 'goedgekeurd',
  'rejected': 'afgewezen',
  'paid': 'betaald',
  'draft': 'concept',
  'expired': 'verlopen',
  'signed': 'ondertekend',
  'Terminated': 'Beëindigd',
  'Temporary': 'Tijdelijk',
  'Permanent': 'Vast',
  'Fixed Term': 'Bepaalde tijd',
  'Ongoing': 'Doorlopend',

  // ── Days / Months ───────────────────────────────────────
  'Sun': 'Zo',
  'Mon': 'Ma',
  'Tue': 'Di',
  'Wed': 'Wo',
  'Thu': 'Do',
  'Fri': 'Vr',
  'Sat': 'Za',
  'Sunday': 'Zondag',
  'Monday': 'Maandag',
  'Tuesday': 'Dinsdag',
  'Wednesday': 'Woensdag',
  'Thursday': 'Donderdag',
  'Friday': 'Vrijdag',
  'Saturday': 'Zaterdag',
  'January': 'Januari',
  'February': 'Februari',
  'March': 'Maart',
  'April': 'April',
  'May': 'Mei',
  'June': 'Juni',
  'July': 'Juli',
  'August': 'Augustus',
  'September': 'September',
  'October': 'Oktober',
  'November': 'November',
  'December': 'December',
  'Weekdays Only': 'Alleen weekdagen',
  'Weekend': 'Weekend',
  'Weekends Only': 'Alleen weekenden',
  'Weekly': 'Wekelijks',
  'Monthly': 'Maandelijks',
  'Yearly': 'Jaarlijks',
  'Hourly': 'Per uur',
  'Daily': 'Dagelijks',

  // ── Dashboard ───────────────────────────────────────────
  "Here's what's happening with your business today.": 'Dit speelt er vandaag in je bedrijf.',
  'Loading dashboard...': 'Dashboard laden...',
  'Total Employees': 'Totaal werknemers',
  '{count} active': '{count} actief',
  'Present Today': 'Vandaag aanwezig',
  '{count} currently working': '{count} nu aan het werk',
  'Payroll This Month': 'Salarissen deze maand',
  '{count} pending': '{count} in behandeling',
  'Total Payroll': 'Totaal salaris',
  'This month': 'Deze maand',
  'this month': 'deze maand',
  'Attendance Trend (Last 7 Days)': 'Aanwezigheidstrend (laatste 7 dagen)',
  'Department Statistics': 'Afdelingsstatistieken',
  'Payroll Trend (Last 6 Months)': 'Salaristrend (laatste 6 maanden)',
  'Top Performers': 'Beste presteerders',
  'Recent Activities': 'Recente activiteiten',
  'Total Attendance': 'Totale aanwezigheid',
  'Unique Employees': 'Unieke werknemers',
  'Total Amount': 'Totaalbedrag',
  '{count} days': '{count} dagen',
  '{hours}h avg': '{hours}u gem.',

  // ── Employees ───────────────────────────────────────────
  'Add Employee': 'Werknemer toevoegen',
  'Add First Employee': 'Eerste werknemer toevoegen',
  'Edit Employee': 'Werknemer bewerken',
  'Employee Details': 'Werknemersgegevens',
  'First Name': 'Voornaam',
  'Last Name': 'Achternaam',
  'Date of Birth': 'Geboortedatum',
  'Hire Date': 'Indiensttredingsdatum',
  'Emergency Contact': 'Noodcontact',
  'Emergency Contact Name': 'Naam noodcontact',
  'Emergency Contact Phone': 'Telefoon noodcontact',
  'ID / Passport Number': 'ID- / paspoortnummer',
  "Driver's License": 'Rijbewijs',
  'Payment Type': 'Betaalwijze',
  'Hourly Rate': 'Uurtarief',
  'Overtime Rate Multiplier': 'Toeslagfactor overuren',
  'Sunday Rate Multiplier': 'Toeslagfactor zondag',
  'Sunday Rate Multiplier *': 'Toeslagfactor zondag *',
  'Holiday Rate Multiplier': 'Toeslagfactor feestdag',
  'Late Deduction %': 'Inhouding te laat %',
  'Grid View': 'Rasterweergave',
  'Table View': 'Tabelweergave',
  'All Status': 'Alle statussen',
  'Search employees...': 'Werknemers zoeken...',
  'Employee updated!': 'Werknemer bijgewerkt!',
  'Employee created!': 'Werknemer aangemaakt!',
  'Error saving employee': 'Fout bij opslaan van werknemer',
  'Please select a photo': 'Selecteer een foto',
  'Photo uploaded successfully!': 'Foto succesvol geüpload!',
  'Error uploading photo': 'Fout bij uploaden van foto',
  'Delete this employee?': 'Deze werknemer verwijderen?',
  'Employee deleted': 'Werknemer verwijderd',
  'Error deleting employee': 'Fout bij verwijderen van werknemer',
  'This employee has payroll, attendance, leave, documents, contracts or shifts and cannot be deleted. Set their status to Inactive instead.': 'Deze werknemer heeft loonstroken, aanwezigheid, verlof, documenten, contracten of diensten en kan niet worden verwijderd. Zet de status op Inactief.',
  'Error loading employee details': 'Fout bij laden van werknemersgegevens',
  'Expired {days}d ago': '{days}d geleden verlopen',
  'Expires in {days}d': 'Verloopt over {days}d',
  'Update Employee': 'Werknemer bijwerken',
  'Create Employee': 'Werknemer aanmaken',
  'No employees found': 'Geen werknemers gevonden',
  'Personal Information': 'Persoonlijke gegevens',
  'Employment Information': 'Dienstverbandgegevens',
  'Compensation': 'Beloning',
  'Emergency & ID': 'Noodgeval & ID',

  // ── Attendance ──────────────────────────────────────────
  'Calendar': 'Kalender',
  'Bulk Operations': 'Bulkacties',
  '⚡ Bulk Operations': '⚡ Bulkacties',
  '🕐 Roster / Schedule': '🕐 Rooster / planning',
  'Roster / Schedule': 'Rooster / planning',
  'Select Employee': 'Selecteer werknemer',
  'Select an employee': 'Selecteer een werknemer',
  'Hours Worked': 'Gewerkte uren',
  'Late Minutes': 'Minuten te laat',
  'Overtime Hours': 'Overuren',
  'Overtime Hours *': 'Overuren *',
  'Overtime Minutes *': 'Overminuten *',
  'Overtime Rate': 'Overurentarief',
  'Mark as Present': 'Als aanwezig markeren',
  'Mark as Absent': 'Als afwezig markeren',
  'Mark as Late': 'Als te laat markeren',
  'Mark as Sick': 'Als ziek markeren',
  'Apply to Selected': 'Toepassen op selectie',
  'Please select at least one employee': 'Selecteer minstens één werknemer',
  'No attendance records': 'Geen aanwezigheidsrecords',
  'Clock In': 'Inklokken',
  'Clock Out': 'Uitklokken',
  'Break Minutes': 'Pauzeminuten',
  'Unpaid break time': 'Onbetaalde pauze',
  'Standard: 8 hours/day': 'Standaard: 8 uur/dag',
  'Sunday Premium': 'Zondagtoeslag',
  'Holiday Premium': 'Feestdagenteoslag',
  'Is Late': 'Is te laat',
  'Is Absent': 'Is afwezig',
  'Is Sick': 'Is ziek',
  'Has Overtime': 'Heeft overuren',
  'Sick Pay %': 'Ziektegeld %',
  'Absent Deduction': 'Inhouding afwezigheid',
  'Percentage of daily rate will be deducted': 'Percentage van het dagtarief wordt ingehouden',
  'Percentage of total monthly salary will be deducted': 'Percentage van het maandloon wordt ingehouden',
  'Week Total:': 'Weektotaal:',
  'Total Hours': 'Totaal uren',
  'Total hours worked': 'Totaal gewerkte uren',
  'Total Days': 'Totaal dagen',
  'This is a leave day and cannot be edited here. Manage it in Leave Requests.': 'Dit is een verlofdag en kan hier niet worden bewerkt. Beheer dit bij verlofaanvragen.',
  'Minutes late (for record keeping)': 'Minuten te laat (voor registratie)',

  // ── Time management / Leaves ────────────────────────────────
  'Leave Requests': 'Verlofaanvragen',
  '🏖️ Leave Requests': '🏖️ Verlofaanvragen',
  '📋 List View': '📋 Lijstweergave',
  'Track attendance, leaves, and work hours': 'Volg aanwezigheid, verlof en werkuren',
  'Record deleted': 'Record verwijderd',
  'Rejection reason:': 'Reden van afwijzing:',
  'Add First Record': 'Eerste record toevoegen',

  // ── Payroll ─────────────────────────────────────────────
  'Calculate Payroll': 'Salaris berekenen',
  'Payroll Records': 'Salarisrecords',
  'Period Start': 'Periode start',
  'Period End': 'Periode einde',
  'Select start date': 'Selecteer startdatum',
  'Select end date': 'Selecteer einddatum',
  'Please select period start and end dates': 'Selecteer start- en einddatum van de periode',
  'End date must be on or after start date': 'Einddatum moet op of na de startdatum liggen',
  'Please add employees first': 'Voeg eerst werknemers toe',
  'Error calculating payroll': 'Fout bij berekenen van salaris',
  'Error cargando records. Revisa consola.': 'Fout bij laden van records. Controleer de console.',
  'Payroll approved successfully!': 'Salaris succesvol goedgekeurd!',
  'Approve': 'Goedkeuren',
  'Reject': 'Afwijzen',
  'Payment Method': 'Betaalmethode',
  'Payment Date': 'Betaaldatum',
  'Bank Transfer': 'Bankoverschrijving',
  'Cash': 'Contant',
  'Check': 'Cheque',
  'Gross Pay': 'Brutoloon',
  'Net Pay': 'Nettoloon',
  'Total Deductions': 'Totaal inhoudingen',
  'Total Earnings': 'Totaal verdiensten',
  'Total Gross Pay:': 'Totaal brutoloon:',
  'Taxes': 'Belastingen',
  'Taxable': 'Belastbaar',
  'Tax Deductible': 'Fiscaal aftrekbaar',
  '📥 Export to Excel': '📥 Exporteren naar Excel',
  'Export to Excel': 'Exporteren naar Excel',
  'Payslip': 'Loonstrook',
  'Download Payslip': 'Loonstrook downloaden',
  'Individual Payroll': 'Individueel salaris',
  'Paramaribo, Suriname': 'Paramaribo, Suriname',
  'Records created: {count}': 'Records aangemaakt: {count}',
  'Check before approving:': 'Controleer vóór goedkeuring:',
  'Some issues:': 'Enkele problemen:',
  'Try changing the date range or calculate new payrolls.': 'Wijzig het datumbereik of bereken nieuwe salarissen.',
  'Total Records': 'Totaal records',

  // ── Payroll calculator ──────────────────────────────────
  'Please select at least one employee': 'Selecteer minstens één werknemer',
  'Unknown error calculating payroll': 'Onbekende fout bij berekenen van salaris',
  'Remove deduction': 'Inhouding verwijderen',
  'Remove tax': 'Belasting verwijderen',
  'Save {count} Payroll Record(s)': '{count} salarisrecord(s) opslaan',
  '⏳ Saving...': '⏳ Opslaan...',

  // ── Consolidation ───────────────────────────────────────
  'Consolidation History': 'Consolidatiegeschiedenis',
  'Consolidate ({count})': 'Consolideren ({count})',
  'Confirm Payment': 'Betaling bevestigen',
  'Total Consolidations': 'Totaal consolidaties',
  '{from} to {to}': '{from} tot {to}',

  // ── Finance ─────────────────────────────────────────────
  'Expenses': 'Uitgaven',
  'Revenues': 'Inkomsten',
  'Budgets': 'Budgetten',
  'Trends': 'Trends',
  'Track expenses, budgets and financial performance': 'Volg uitgaven, budgetten en financiële prestaties',
  'Add Expense': 'Uitgave toevoegen',
  'Add Revenue': 'Inkomst toevoegen',
  'Add Budget': 'Budget toevoegen',
  'Create First Expense': 'Eerste uitgave aanmaken',
  'Create First Revenue': 'Eerste inkomst aanmaken',
  'Create First Budget': 'Eerste budget aanmaken',
  'Upload Receipt': 'Bon uploaden',
  'Please select a file': 'Selecteer een bestand',
  'Revenue deleted': 'Inkomst verwijderd',
  'Reason for rejection:': 'Reden van afwijzing:',
  'Update cash...': 'Kas bijwerken...',
  'Vendor': 'Leverancier',
  'Office Supplies': 'Kantoorbenodigdheden',
  'Sales': 'Verkoop',
  'Total Expenses': 'Totale uitgaven',
  'Total Expenses (Approved)': 'Totale uitgaven (goedgekeurd)',
  'Total Revenues': 'Totale inkomsten',
  'Total Taxes': 'Totale belastingen',
  'SRD - Surinamese Dollar': 'SRD - Surinaamse dollar',
  'USD - US Dollar': 'USD - Amerikaanse dollar',

  // ── Tax ─────────────────────────────────────────────────
  'Tax Configuration': 'Belastingconfiguratie',
  'Tax Name': 'Belastingnaam',
  'Tax Name *': 'Belastingnaam *',
  'Tax Code': 'Belastingcode',
  'Tax Code *': 'Belastingcode *',
  'Tax Rate': 'Belastingtarief',
  'Tax Rate (%) *': 'Belastingtarief (%) *',
  'Tax Rate:': 'Belastingtarief:',
  'Tax Type': 'Belastingtype',
  'Tax Type *': 'Belastingtype *',
  '➕ Add Tax Bracket': '➕ Belastingschijf toevoegen',
  'Add First Bracket': 'Eerste schijf toevoegen',
  'Add First Configuration': 'Eerste configuratie toevoegen',
  'Create First Tax': 'Eerste belasting aanmaken',
  'Tax bracket created!': 'Belastingschijf aangemaakt!',
  'Tax bracket updated!': 'Belastingschijf bijgewerkt!',
  'Tax bracket deleted successfully': 'Belastingschijf succesvol verwijderd',
  'Delete this tax bracket?': 'Deze belastingschijf verwijderen?',
  'Tax created but error saving brackets: ': 'Belasting aangemaakt, maar fout bij opslaan van schijven: ',
  'Single tax rate applied to income': 'Enkel tarief toegepast op inkomen',
  'Tiered/Progressive (Ranges)': 'Getrapt / progressief (schijven)',
  'To (leave empty for ∞)': 'Tot (leeg laten voor ∞)',
  'Taxable (subject to income tax)': 'Belastbaar (onderworpen aan loonbelasting)',
  'Please enter a valid gross pay amount': 'Voer een geldig brutoloon in',
  'Please enter a valid overtime gross amount': 'Voer een geldig bruto-overurenbedrag in',
  'Test the Loonbelasting calculation with a sample gross pay': 'Test de loonbelastingberekening met een voorbeeldbrutoloon',
  'Test the overtime tax calculation with a sample gross amount': 'Test de overurenbelasting met een voorbeeldbedrag',
  'Test the progressive Loonbelasting calculation using configured brackets': 'Test de progressieve loonbelasting met de ingestelde schijven',
  'Calculate': 'Berekenen',
  '🧮 Calculate with Brackets': '🧮 Berekenen met schijven',
  'Overtime Tax Configuration': 'Configuratie overurenbelasting',
  'Total Tax: SRD {amount}': 'Totale belasting: SRD {amount}',

  // ── Benefits / Deductions ───────────────────────────────
  'Benefit Types': 'Toeslagtypen',
  'Employee Benefits': 'Werknemerstoeslagen',
  'Assign Benefit': 'Toeslag toewijzen',
  'Assign First Benefit': 'Eerste toeslag toewijzen',
  'This benefit is taxable': 'Deze toeslag is belastbaar',
  '📋 Deductions & Benefits': '📋 Inhoudingen & toeslagen',
  'Add First Deduction': 'Eerste inhouding toevoegen',
  '➕ Create First Deduction': '➕ Eerste inhouding aanmaken',
  'Deduction updated!': 'Inhouding bijgewerkt!',
  'Deduction created!': 'Inhouding aangemaakt!',
  'Error loading deductions': 'Fout bij laden van inhoudingen',
  'Unique identifier (uppercase, no spaces)': 'Unieke code (hoofdletters, geen spaties)',
  'Unique identifier (will be converted to uppercase)': 'Unieke code (wordt omgezet naar hoofdletters)',

  // ── Contracts / Documents ───────────────────────────────
  'Create Contract': 'Contract aanmaken',
  'Create First Contract': 'Eerste contract aanmaken',
  'Create Template': 'Sjabloon aanmaken',
  'Templates': 'Sjablonen',
  'Template': 'Sjabloon',
  'Template deleted': 'Sjabloon verwijderd',
  'Template will auto-fill terms and benefits': 'Sjabloon vult voorwaarden en toeslagen automatisch in',
  'Terms:': 'Voorwaarden:',
  'Set': 'Instellen',
  "s rate": 'tarief',
  "s salary": 'salaris',
  'Upload Document': 'Document uploaden',
  'Upload First Document': 'Eerste document uploaden',
  'Please select a file': 'Selecteer een bestand',

  // ── Approvals ───────────────────────────────────────────
  'Approval Requests': 'Goedkeuringsverzoeken',
  'Review and approve pending requests': 'Beoordeel en keur openstaande verzoeken goed',
  'Pending ({count})': 'In behandeling ({count})',
  'My Requests': 'Mijn verzoeken',
  'Loading requests...': 'Verzoeken laden...',
  'No requests found': 'Geen verzoeken gevonden',
  'Requested by:': 'Aangevraagd door:',
  'Current Data:': 'Huidige gegevens:',
  'Requested Changes:': 'Aangevraagde wijzigingen:',
  'Request approved successfully!': 'Verzoek succesvol goedgekeurd!',
  'Error approving request': 'Fout bij goedkeuren van verzoek',
  'Please provide a reason for rejection': 'Geef een reden voor afwijzing',
  'Request rejected': 'Verzoek afgewezen',
  'Error rejecting request': 'Fout bij afwijzen van verzoek',
  'Salary Change': 'Salariswijziging',
  'Termination': 'Beëindiging',
  'Expense': 'Uitgave',

  // ── Reports ─────────────────────────────────────────────
  'Attendance Report': 'Aanwezigheidsrapport',
  'Payroll Summary': 'Salarissamenvatting',
  'Tax Report': 'Belastingrapport',
  '💸 Expenses': '💸 Uitgaven',

  // ── Settings ────────────────────────────────────────────
  'System Settings': 'Systeeminstellingen',
  'Configure system-wide settings': 'Configureer systeeminstellingen',
  'Company Information': 'Bedrijfsgegevens',
  'Company Name *': 'Bedrijfsnaam *',
  'System configuration and management': 'Systeemconfiguratie en beheer',
  'Sunday premium checkbox:': 'Zondagtoeslag aanvinken:',
  'Sunday rate:': 'Zondagsstarief:',
  'When enabled, Holiday hours will be paid at the configured rate multiplier': 'Indien ingeschakeld worden feestdaguren uitbetaald met de ingestelde toeslagfactor',
  'When enabled, Sunday hours will be paid at the configured rate multiplier': 'Indien ingeschakeld worden zondaguren uitbetaald met de ingestelde toeslagfactor',
  'Working days per month used to prorate monthly salaries. Saved with the Save button in the Sunday/Holiday Premium section below.': 'Werkdagen per maand om maandlonen te prorateren. Wordt opgeslagen met de knop Opslaan bij zondag-/feestdagenteoslag.',
  '✅ Premium configuration saved successfully!': '✅ Premieconfiguratie succesvol opgeslagen!',
  '✅ Tax bracket saved successfully!': '✅ Belastingschijf succesvol opgeslagen!',
  'Failed to save': 'Opslaan mislukt',
  'Failed to save bracket': 'Schijf opslaan mislukt',

  // ── Admin ───────────────────────────────────────────────
  'Access Denied: Super Admin only': 'Toegang geweigerd: alleen superbeheerder',
  'This area is restricted to Super Administrators only.': 'Dit gebied is alleen toegankelijk voor superbeheerders.',
  'Activity Logs': 'Activiteitenlogboeken',
  'Permissions (Roles)': 'Rechten (rollen)',
  'Statistics': 'Statistieken',
  'User created successfully!': 'Gebruiker succesvol aangemaakt!',
  'Total Users': 'Totaal gebruikers',
  'Total Logs': 'Totaal logregels',
  'Timestamp': 'Tijdstempel',
  'User permissions updated!': 'Gebruikersrechten succesvol bijgewerkt!',
  'User role updated!': 'Gebruikersrol succesvol bijgewerkt!',
  'User deleted!': 'Gebruiker succesvol verwijderd!',
  'Your own permissions were updated. The changes apply immediately.': 'Je eigen rechten zijn bijgewerkt. De wijzigingen gelden meteen.',

  // ── Profile / Security / Activity ───────────────────────
  'Manage your personal information': 'Beheer je persoonlijke gegevens',
  'Change Photo': 'Foto wijzigen',
  'Max size: 5MB': 'Max. grootte: 5 MB',
  'Email cannot be changed': 'E-mail kan niet worden gewijzigd',
  'Email (Read-only)': 'E-mail (alleen-lezen)',
  'Edit Information': 'Gegevens bewerken',
  'Account Information': 'Accountgegevens',
  'Account Created:': 'Account aangemaakt:',
  'Last Login:': 'Laatste login:',
  'Role:': 'Rol:',
  'Current Password': 'Huidig wachtwoord',
  'New Password': 'Nieuw wachtwoord',
  'Confirm New Password': 'Bevestig nieuw wachtwoord',
  '❌ Cancel': '❌ Annuleren',
  'Last Login': 'Laatste login',
  'Edit Profile': 'Profiel bewerken',
  'Profile updated successfully!': 'Profiel succesvol bijgewerkt!',
  'Error updating profile': 'Fout bij bijwerken van profiel',
  'File size must be less than 5MB': 'Bestand moet kleiner zijn dan 5 MB',
  'Please select an image file': 'Selecteer een afbeeldingsbestand',
  'New passwords do not match!': 'Nieuwe wachtwoorden komen niet overeen!',
  'Password changed successfully!': 'Wachtwoord succesvol gewijzigd!',
  'Error changing password': 'Fout bij wijzigen van wachtwoord',
  'Security & Permissions': 'Beveiliging en rechten',
  'Manage user access and permissions': 'Beheer gebruikerstoegang en rechten',
  'Select a user to manage permissions': 'Selecteer een gebruiker om rechten te beheren',
  'Permissions for {name}': 'Rechten voor {name}',
  'Loading permissions...': 'Rechten laden...',
  'Save Permissions': 'Rechten opslaan',
  'Permissions updated successfully!': 'Rechten succesvol bijgewerkt!',
  'Error updating permissions': 'Fout bij bijwerken van rechten',
  'Activity Log': 'Activiteitenlogboek',
  'Track your account activity and changes': 'Volg de activiteit en wijzigingen van je account',
  'All Activities': 'Alle activiteiten',
  'Login/Logout': 'Inloggen/uitloggen',
  'Profile Changes': 'Profielwijzigingen',
  'Employee Actions': 'Werknemersacties',
  'Loading activity log...': 'Activiteitenlogboek laden...',
  'No activities found': 'Geen activiteiten gevonden',

  // ── Notifications ───────────────────────────────────────
  '🔔 General Settings': '🔔 Algemene instellingen',
  'Email Notifications': 'E-mailmeldingen',
  'Receive notifications via email': 'Meldingen per e-mail ontvangen',
  'In-App Notifications': 'Meldingen in de app',
  'Receive notifications in the app': 'Meldingen in de app ontvangen',
  '⏰ Attendance & Time': '⏰ Aanwezigheid & tijd',
  'Employee Absent': 'Werknemer afwezig',
  'When an employee is marked as absent': 'Wanneer een werknemer als afwezig is gemarkeerd',
  'Employee Sick': 'Werknemer ziek',
  'When an employee is marked as sick': 'Wanneer een werknemer als ziek is gemarkeerd',
  'Employee Late': 'Werknemer te laat',
  'When an employee arrives late': 'Wanneer een werknemer te laat komt',
  'Overtime Submitted': 'Overuren ingediend',
  'When overtime is submitted': 'Wanneer overuren worden ingediend',
  '📜 Contracts': '📜 Contracten',
  'Contract Expiring (30 days)': 'Contract verloopt (30 dagen)',
  'Contract expires in 30 days': 'Contract verloopt over 30 dagen',
  'Contract Expiring (15 days)': 'Contract verloopt (15 dagen)',
  'Contract expires in 15 days': 'Contract verloopt over 15 dagen',
  'Contract Expiring (7 days)': 'Contract verloopt (7 dagen)',
  'Contract expires in 7 days': 'Contract verloopt over 7 dagen',
  'Contract Expired': 'Contract verlopen',
  'Contract has expired': 'Contract is verlopen',
  'New Leave Request': 'Nieuwe verlofaanvraag',
  'When a new leave request is submitted': 'Wanneer een nieuwe verlofaanvraag wordt ingediend',
  'Payroll Generated': 'Salaris gegenereerd',
  'When payroll is generated': 'Wanneer het salaris wordt gegenereerd',
  'When a new expense is submitted': 'Wanneer een nieuwe uitgave wordt ingediend',
  'When an expense is approved': 'Wanneer een uitgave wordt goedgekeurd',
  'When an expense is rejected': 'Wanneer een uitgave wordt afgewezen',
  'When budget usage exceeds 80%': 'Wanneer het budgetgebruik boven 80% komt',
  'When overtime is approved': 'Wanneer overuren worden goedgekeurd',
  'When overtime is rejected': 'Wanneer overuren worden afgewezen',
  'When overtime is submitted for approval': 'Wanneer overuren ter goedkeuring worden ingediend',
  'When a new document is uploaded': 'Wanneer een nieuw document wordt geüpload',
  'When a document is about to expire': 'Wanneer een document bijna verloopt',
  'When employee information is updated': 'Wanneer werknemersgegevens worden bijgewerkt',
  'Overtime Approved': 'Overuren goedgekeurd',
  'Overtime Rejected': 'Overuren afgewezen',
  'Error loading notification preferences': 'Fout bij laden van meldingsvoorkeuren',
  '✅ Notification preferences saved successfully!': '✅ Meldingsvoorkeuren succesvol opgeslagen!',
  'Error saving notification preferences': 'Fout bij opslaan van meldingsvoorkeuren',

  // ── Holidays / Overtime ─────────────────────────────────
  'Error loading public holidays': 'Fout bij laden van feestdagen',
  'Holiday updated successfully!': 'Feestdag succesvol bijgewerkt!',
  'Holiday created successfully!': 'Feestdag succesvol aangemaakt!',
  'Error saving holiday': 'Fout bij opslaan van feestdag',
  'Add First Holiday': 'Eerste feestdag toevoegen',
  'Add Overtime Type': 'Overurentype toevoegen',
  'Optional description...': 'Optionele beschrijving...',

  // ── Error boundary ──────────────────────────────────────
  'Chart Display Error': 'Fout bij weergave van grafiek',
  'Unable to render this chart. This might be a temporary issue.': 'Deze grafiek kan niet worden weergegeven. Dit kan tijdelijk zijn.',
  '🔄 Refresh Page': '🔄 Pagina vernieuwen',

  // ── Payslip PDF ─────────────────────────────────────────
  'PAYROLL SLIP': 'LOONSTROOK',
  'PAY PERIOD:': 'LOONPERIODE:',
  'PAYMENT DATE:': 'BETAALDATUM:',
  'STATUS:': 'STATUS:',
  'PAYSLIP ID:': 'LOONSTROOK-ID:',
  'EMPLOYEE INFORMATION': 'WERKNEMERSGEGEVENS',
  'WORK DETAILS': 'WERKGEGEVENS',
  'Name:': 'Naam:',
  'Position:': 'Functie:',
  'Department:': 'Afdeling:',
  'Payment:': 'Betaling:',
  'Address:': 'Adres:',
  'Regular Hours:': 'Normale uren:',
  'Overtime Hours:': 'Overuren:',
  'Total Hours:': 'Totaal uren:',
  'OT Rate:': 'OT-tarief:',
  'Total Late Minutes:': 'Totaal minuten te laat:',
  'Sick Days:': 'Ziektedagen:',
  'This is a computer-generated payslip and does not require a signature.': 'Dit is een digitaal gegenereerde loonstrook en vereist geen handtekening.',

  // ── Currency / misc ─────────────────────────────────────
  'taxpayers': 'belastingplichtigen',
  'total assignments': 'totaal toewijzingen',
  'total earnings': 'totaal verdiensten',
  'total payout': 'totaal uitbetaald',
  'taxes + other': 'belastingen + overig',
  'sick/leave days': 'ziekte-/verlofdagen',
  '(effective)': '(effectief)',

  // ── Employees (page extras) ─────────────────────────────
  'Deduction added!': 'Inhouding toegevoegd!',
  'Error: {message}': 'Fout: {message}',
  'Error saving deduction': 'Fout bij opslaan van inhouding',
  'Deactivate this deduction?': 'Deze inhouding deactiveren?',
  'Activate this deduction?': 'Deze inhouding activeren?',
  'Error toggling deduction': 'Fout bij wijzigen van inhouding',
  'Remove "{name}" deduction?': 'Inhouding "{name}" verwijderen?',
  'Deduction removed!': 'Inhouding verwijderd!',
  'Error removing deduction': 'Fout bij verwijderen van inhouding',
  'Manage your workforce': 'Beheer je personeel',
  'On Leave': 'Met verlof',
  'on_leave': 'met verlof',
  'Loading employees...': 'Werknemers laden...',
  'Employee ID': 'Werknemers-ID',
  'Photo': 'Foto',
  'Create New Employee': 'Nieuwe werknemer aanmaken',
  'First Name *': 'Voornaam *',
  'Enter first name': 'Voer voornaam in',
  'Last Name *': 'Achternaam *',
  'Enter last name': 'Voer achternaam in',
  'Email *': 'E-mail *',
  'Phone Number': 'Telefoonnummer',
  'Clear date': 'Datum wissen',
  "Optional - Employee's date of birth": 'Optioneel - geboortedatum van de werknemer',
  'Enter complete address': 'Voer volledig adres in',
  'Identification Documents': 'Identiteitsdocumenten',
  'Enter ID or Passport number': 'Voer ID- of paspoortnummer in',
  "Enter driver's license number": 'Voer rijbewijsnummer in',
  'Contact Name': 'Contactnaam',
  'Emergency contact name': 'Naam noodcontact',
  'Contact Phone': 'Contacttelefoon',
  'Department *': 'Afdeling *',
  'Select Department': 'Selecteer afdeling',
  'Administration': 'Administratie',
  'Operations': 'Operaties',
  'Human Resources': 'Personeelszaken',
  'IT': 'IT',
  'Position *': 'Functie *',
  'Job title': 'Functietitel',
  'Hire Date *': 'Indiensttredingsdatum *',
  'Hire date cannot be changed after employee is created': 'Indiensttredingsdatum kan niet meer worden gewijzigd nadat de werknemer is aangemaakt',
  'Date when employee was hired': 'Datum waarop de werknemer in dienst trad',
  'Payment Type *': 'Betaalwijze *',
  'Monthly Salary': 'Maandsalaris',
  'Monthly Salary *': 'Maandsalaris *',
  'Fixed monthly salary amount': 'Vast maandsalaris',
  'Hourly Rate (SRD) *': 'Uurtarief (SRD) *',
  'Amount paid per hour worked': 'Bedrag per gewerkt uur',
  'Overtime Multiplier': 'Toeslagfactor overuren',
  'Multiplier for overtime pay (e.g., 1.5 = time and a half)': 'Factor voor overuren (bijv. 1,5 = anderhalf keer)',
  'Multiplier for Sunday work (default: 1.5x = time and a half)': 'Factor voor zondagwerk (standaard: 1,5x = anderhalf keer)',
  'Holiday Rate Multiplier *': 'Toeslagfactor feestdag *',
  'Multiplier for Holiday work (default: 2.0x = double time)': 'Factor voor feestdagwerk (standaard: 2,0x = dubbel tarief)',
  'Late Deduction % *': 'Inhouding te laat % *',
  "Percentage to deduct from day's pay when late (default: 10%)": 'Percentage dat bij te laat komen van het dagloon wordt ingehouden (standaard: 10%)',
  'EUR - Euro': 'EUR - Euro',
  "Select the currency for this employee's payment": 'Selecteer de valuta voor de betaling van deze werknemer',
  'Status *': 'Status *',
  'Update Profile Photo': 'Profielfoto bijwerken',
  'Choose Photo': 'Foto kiezen',
  'JPG or PNG, max 5MB': 'JPG of PNG, max. 5 MB',
  'Employee ID:': 'Werknemers-ID:',
  'Phone:': 'Telefoon:',
  'Email:': 'E-mail:',
  'Date of Birth:': 'Geboortedatum:',
  'ID / Passport:': 'ID / paspoort:',
  "Driver's License:": 'Rijbewijs:',
  'Contact Name:': 'Contactnaam:',
  'Contact Phone:': 'Contacttelefoon:',
  'Hire Date:': 'Indiensttredingsdatum:',
  'Salary:': 'Salaris:',
  '+ Add Deduction': '+ Inhouding toevoegen',
  'No deductions assigned': 'Geen inhoudingen toegewezen',
  'From:': 'Van:',
  'To:': 'Tot:',
  'Deactivate': 'Deactiveren',
  'Activate': 'Activeren',
  'Quick Actions': 'Snelle acties',
  'View Documents': 'Documenten bekijken',
  'View Contracts': 'Contracten bekijken',
  'View Attendance': 'Aanwezigheid bekijken',
  'View Payroll': 'Salaris bekijken',
  'Edit Deduction': 'Inhouding bewerken',
  'Deduction Type *': 'Inhoudingstype *',
  'Select deduction...': 'Selecteer inhouding...',
  '{name} (Default: {currency} {amount})': '{name} (Standaard: {currency} {amount})',
  'Amount (SRD) *': 'Bedrag (SRD) *',
  'Optional - when deduction starts': 'Optioneel - wanneer de inhouding ingaat',
  'Optional - when deduction ends': 'Optioneel - wanneer de inhouding stopt',
  'Update Deduction': 'Inhouding bijwerken',
  'Add Deduction': 'Inhouding toevoegen',

  // ── Documents (page extras) ─────────────────────────────
  'Document uploaded successfully!': 'Document succesvol geüpload!',
  'Error uploading document': 'Fout bij uploaden van document',
  'Error downloading document': 'Fout bij downloaden van document',
  'Document updated!': 'Document bijgewerkt!',
  'Error updating document': 'Fout bij bijwerken van document',
  'Delete this document? This cannot be undone.': 'Dit document verwijderen? Dit kan niet ongedaan worden gemaakt.',
  'Document deleted': 'Document verwijderd',
  'Error deleting document': 'Fout bij verwijderen van document',
  '0 Bytes': '0 bytes',
  'Bytes': 'bytes',
  'Document Management': 'Documentbeheer',
  'Manage employee documents and files': 'Beheer werknemersdocumenten en bestanden',
  'All Categories': 'Alle categorieën',
  'Expired': 'Verlopen',
  'Archived': 'Gearchiveerd',
  'archived': 'gearchiveerd',
  'Loading documents...': 'Documenten laden...',
  'No documents found': 'Geen documenten gevonden',
  'Expires: {date}': 'Verloopt: {date}',
  'Employee *': 'Werknemer *',
  'Select employee': 'Selecteer werknemer',
  'Category *': 'Categorie *',
  'Select category': 'Selecteer categorie',
  'Title *': 'Titel *',
  'e.g., Employment Contract 2025': 'bijv. Arbeidscontract 2025',
  'File *': 'Bestand *',
  'Allowed: PDF, DOC, DOCX, JPG, PNG, TXT (Max 10MB)': 'Toegestaan: PDF, DOC, DOCX, JPG, PNG, TXT (max. 10 MB)',
  'Expiration Date (Optional)': 'Vervaldatum (optioneel)',
  'Optional notes...': 'Optionele opmerkingen...',
  'Edit Document': 'Document bewerken',
  'Expiration Date': 'Vervaldatum',

  // ── Approvals (page extras) ─────────────────────────────
  'Approved by:': 'Goedgekeurd door:',
  'Rejected by:': 'Afgewezen door:',
  'Approve Request': 'Verzoek goedkeuren',
  'Approval Notes (Optional)': 'Goedkeuringsopmerkingen (optioneel)',
  'Add any notes...': 'Voeg eventuele opmerkingen toe...',
  'Reject Request': 'Verzoek afwijzen',
  'Reason for Rejection *': 'Reden van afwijzing *',
  'Please provide a reason for rejection...': 'Geef een reden voor afwijzing...',

  // ── Contracts (page extras) ─────────────────────────────
  'Error loading employee data. Please enter salary manually.': 'Fout bij laden van werknemersgegevens. Voer het salaris handmatig in.',
  'Contract created successfully!': 'Contract succesvol aangemaakt!',
  'Error creating contract': 'Fout bij aanmaken van contract',
  'Contract updated!': 'Contract bijgewerkt!',
  'Error updating contract': 'Fout bij bijwerken van contract',
  'Activate this contract?': 'Dit contract activeren?',
  'Contract activated!': 'Contract geactiveerd!',
  'Error activating contract': 'Fout bij activeren van contract',
  'Enter termination reason:': 'Voer reden van beëindiging in:',
  'Contract terminated': 'Contract beëindigd',
  'Error terminating contract': 'Fout bij beëindigen van contract',
  'Delete this contract? Only drafts can be deleted.': 'Dit contract verwijderen? Alleen concepten kunnen worden verwijderd.',
  'Contract deleted': 'Contract verwijderd',
  'Error deleting contract': 'Fout bij verwijderen van contract',
  'Template created successfully!': 'Sjabloon succesvol aangemaakt!',
  'Error creating template': 'Fout bij aanmaken van sjabloon',
  'Template updated!': 'Sjabloon bijgewerkt!',
  'Error updating template': 'Fout bij bijwerken van sjabloon',
  'Delete this template? This cannot be undone.': 'Dit sjabloon verwijderen? Dit kan niet ongedaan worden gemaakt.',
  'Error deleting template': 'Fout bij verwijderen van sjabloon',
  'Contract Management': 'Contractbeheer',
  'Manage employment contracts and templates': 'Beheer arbeidscontracten en sjablonen',
  'New Contract': 'Nieuw contract',
  'New Template': 'Nieuw sjabloon',
  'Draft': 'Concept',
  'All Types': 'Alle typen',
  'Full-Time': 'Voltijd',
  'Part-Time': 'Deeltijd',
  'Contractor': 'Contractant',
  'Internship': 'Stage',
  'Loading contracts...': 'Contracten laden...',
  'No contracts found': 'Geen contracten gevonden',
  'Hourly Rate:': 'Uurtarief:',
  '{amount}/hr': '{amount}/uur',
  'Terminate': 'Beëindigen',
  'Loading templates...': 'Sjablonen laden...',
  'Duration:': 'Duur:',
  '{count} months': '{count} maanden',
  'Probation:': 'Proeftijd:',
  'Benefits:': 'Toeslagen:',
  '{count} Vacation Days': '{count} vakantiedagen',
  '{count} Sick Leave Days': '{count} ziektedagen',
  'Notice Period: {days} days': 'Opzegtermijn: {days} dagen',
  'Create New Contract': 'Nieuw contract aanmaken',
  'Employee data will auto-fill salary and payment info': 'Werknemersgegevens vullen salaris- en betalingsinfo automatisch in',
  'Template (Optional)': 'Sjabloon (optioneel)',
  'No template (custom contract)': 'Geen sjabloon (aangepast contract)',
  'Autocompleted from Employee:': 'Automatisch ingevuld vanuit werknemer:',
  'Payment Structure:': 'Betaalstructuur:',
  'Monthly Salary:': 'Maandsalaris:',
  '{currency} {amount}/hr': '{currency} {amount}/uur',
  'Currency:': 'Valuta:',
  'Overtime Eligible:': 'Gerechtigd tot overuren:',
  'All values can be edited before saving': 'Alle waarden kunnen vóór het opslaan worden bewerkt',
  'Applied from Template:': 'Toegepast vanuit sjabloon:',
  'Contract Type:': 'Contracttype:',
  'Not set': 'Niet ingesteld',
  ' Health Insurance': ' Ziektekostenverzekering',
  ', {count} vacation days': ', {count} vakantiedagen',
  'Loaded': 'Geladen',
  'Contract Type *': 'Contracttype *',
  'Payment Structure *': 'Betaalstructuur *',
  'End Date (Optional)': 'Einddatum (optioneel)',
  'Probation End Date': 'Einde proeftijd',
  'Hourly Rate *': 'Uurtarief *',
  'Currency *': 'Valuta *',
  'Vacation Days/Year': 'Vakantiedagen/jaar',
  'Sick Leave Days/Year': 'Ziektedagen/jaar',
  'Overtime Eligible': 'Gerechtigd tot overuren',
  'Additional Benefits Description': 'Beschrijving extra toeslagen',
  'e.g., Transportation allowance, meal vouchers, etc.': 'bijv. reiskostenvergoeding, maaltijdcheques, enz.',
  'Terms and Conditions': 'Algemene voorwaarden',
  'Enter general terms and conditions...': 'Voer algemene voorwaarden in...',
  'Notice Period (days)': 'Opzegtermijn (dagen)',
  'Special Clauses': 'Speciale clausules',
  'Enter any special clauses or conditions...': 'Voer eventuele speciale clausules of voorwaarden in...',
  'Create New Template': 'Nieuw sjabloon aanmaken',
  'Template Name *': 'Sjabloonnaam *',
  'e.g., Full-Time Security Guard Contract': 'bijv. Voltijdcontract beveiliger',
  'Default Duration (months) *': 'Standaardduur (maanden) *',
  'Default Probation (months) *': 'Standaardproeftijd (maanden) *',
  'Notice Period (days) *': 'Opzegtermijn (dagen) *',
  'Default Compensation (Optional)': 'Standaardbeloning (optioneel)',
  'Default Salary (if monthly)': 'Standaardsalaris (indien maandelijks)',
  "Leave empty to use employee's salary": 'Leeg laten om het salaris van de werknemer te gebruiken',
  'Default Hourly Rate (if hourly)': 'Standaard uurtarief (indien per uur)',
  "Leave empty to use employee's rate": 'Leeg laten om het tarief van de werknemer te gebruiken',
  'Includes Health Insurance': 'Inclusief ziektekostenverzekering',
  'Includes Overtime Pay': 'Inclusief overurenvergoeding',
  'Custom Benefits': 'Aangepaste toeslagen',
  'e.g., Transportation allowance, meal vouchers': 'bijv. reiskostenvergoeding, maaltijdcheques',
  'Terms and Conditions *': 'Algemene voorwaarden *',
  'Enter standard terms and conditions for this type of contract...': 'Voer standaardvoorwaarden in voor dit type contract...',
  'Active (available for use)': 'Actief (beschikbaar voor gebruik)',
  'Edit Template': 'Sjabloon bewerken',
  'Update Template': 'Sjabloon bijwerken',
  'Health Insurance': 'Ziektekostenverzekering',
  'Project-Based': 'Projectgebaseerd',

  // ── Stored status / type values ─────────────────────────
  'terminated': 'beëindigd',
  'full-time': 'voltijd',
  'part-time': 'deeltijd',
  'contractor': 'contractant',
  'temporary': 'tijdelijk',
  'internship': 'stage',
  'project-based': 'projectgebaseerd',
  'monthly': 'maandelijks',
  'hourly': 'per uur',
  'daily': 'dagelijks',
  'pending_signature': 'wacht op ondertekening',
  'fixed': 'vast',
  'percentage': 'percentage',

  // ── Time Management page ────────────────────────────────
  '✅ Clocked in successfully!': '✅ Succesvol ingeklokt!',
  'Error clocking in': 'Fout bij inklokken',
  '✅ Attendance record added!': '✅ Aanwezigheidsrecord toegevoegd!',
  'Error adding attendance': 'Fout bij toevoegen van aanwezigheid',
  '✅ Attendance updated!': '✅ Aanwezigheid bijgewerkt!',
  'Error updating attendance': 'Fout bij bijwerken van aanwezigheid',
  'Delete this record?': 'Dit record verwijderen?',
  'Error deleting attendance': 'Fout bij verwijderen van aanwezigheid',
  'Number of days must be greater than 0': 'Aantal dagen moet groter zijn dan 0',
  'End date must be after or equal to start date': 'Einddatum moet op of na de startdatum liggen',
  '✅ Leave request submitted for {days} days': '✅ Verlofaanvraag ingediend voor {days} dagen',
  'Error requesting leave': 'Fout bij aanvragen van verlof',
  '✅ Leave approved!': '✅ Verlof goedgekeurd!',
  'Error approving leave': 'Fout bij goedkeuren van verlof',
  'Leave rejected': 'Verlof afgewezen',
  'Error rejecting leave': 'Fout bij afwijzen van verlof',
  'Clock In/Out': 'In-/uitklokken',
  'Add Hours': 'Uren toevoegen',
  'Leaves': 'Verlof',
  'List View': 'Lijstweergave',
  'Please select an employee to view calendar': 'Selecteer een werknemer om de kalender te bekijken',
  'Leave': 'Verlof',
  'Loading records...': 'Records laden...',
  'Please select an employee': 'Selecteer een werknemer',
  'No attendance records for this period': 'Geen aanwezigheidsrecords voor deze periode',
  'Work': 'Werk',
  'days used this year': 'dagen gebruikt dit jaar',
  'Request Leave': 'Verlof aanvragen',
  'Select an employee to view leave requests': 'Selecteer een werknemer om verlofaanvragen te bekijken',
  'No leave requests': 'Geen verlofaanvragen',
  'Days:': 'Dagen:',
  'No reason provided': 'Geen reden opgegeven',
  'Requested:': 'Aangevraagd:',
  'Add Attendance Record': 'Aanwezigheidsrecord toevoegen',
  'Date *': 'Datum *',
  'Hours Worked *': 'Gewerkte uren *',
  'Pending Approval': 'Wacht op goedkeuring',
  'Optional notes (e.g., worked overtime, early leave...)': 'Optionele opmerkingen (bijv. overuren, eerder weg...)',
  'Add Record': 'Record toevoegen',
  'Edit Attendance': 'Aanwezigheid bewerken',
  'Date:': 'Datum:',
  'Employee:': 'Werknemer:',
  'Leave Type *': 'Verloftype *',
  'Select leave type': 'Selecteer verloftype',
  '(Paid)': '(Betaald)',
  '(Unpaid)': '(Onbetaald)',
  'End Date *': 'Einddatum *',
  '💡 Suggested: {days} working days (excluding weekends)': '💡 Suggestie: {days} werkdagen (weekenden uitgezonderd)',
  'Use this': 'Dit gebruiken',
  'Number of Days *': 'Aantal dagen *',
  'e.g., 1, 2.5, 5': 'bijv. 1, 2,5, 5',
  'Enter the number of leave days (0.5 for half day, 1 for full day, etc.)': 'Voer het aantal verlofdagen in (0,5 voor een halve dag, 1 voor een hele dag, enz.)',
  'Reason *': 'Reden *',
  'Please provide a reason for your leave request...': 'Geef een reden voor je verlofaanvraag...',
  'Leave request will be sent for approval. Please verify the number of days according to company policy.': 'De verlofaanvraag wordt ter goedkeuring verstuurd. Controleer het aantal dagen volgens het bedrijfsbeleid.',
  'Submit Request': 'Aanvraag indienen',
  'Location (Optional)': 'Locatie (optioneel)',
  'e.g., Office, Remote, Site A': 'bijv. kantoor, remote, locatie A',

  // ── Public Holidays page ────────────────────────────────
  'Are you sure you want to delete this holiday?': 'Weet je zeker dat je deze feestdag wilt verwijderen?',
  'Holiday deleted successfully!': 'Feestdag succesvol verwijderd!',
  'Error deleting holiday': 'Fout bij verwijderen van feestdag',
  'Error updating holiday status': 'Fout bij bijwerken van feestdagstatus',
  'Manage company public holidays': 'Beheer de feestdagen van het bedrijf',
  'Add Holiday': 'Feestdag toevoegen',
  'Loading holidays...': 'Feestdagen laden...',
  'No public holidays found for {year}': 'Geen feestdagen gevonden voor {year}',
  'Recurring': 'Terugkerend',
  'Edit Holiday': 'Feestdag bewerken',
  'Add New Holiday': 'Nieuwe feestdag toevoegen',
  'Name *': 'Naam *',
  'e.g., Independence Day': 'bijv. Onafhankelijkheidsdag',
  'Country': 'Land',
  'Suriname': 'Suriname',
  'Netherlands': 'Nederland',
  'United States': 'Verenigde Staten',
  'Recurring annually': 'Jaarlijks terugkerend',

  // ── Overtime Configuration page ─────────────────────────
  'Error loading overtime configurations': 'Fout bij laden van overurenconfiguraties',
  'Configuration updated!': 'Configuratie bijgewerkt!',
  'Configuration created!': 'Configuratie aangemaakt!',
  'Error saving configuration': 'Fout bij opslaan van configuratie',
  'Delete this overtime configuration? This cannot be undone.': 'Deze overurenconfiguratie verwijderen? Dit kan niet ongedaan worden gemaakt.',
  'Configuration deleted successfully': 'Configuratie succesvol verwijderd',
  'Error deleting configuration': 'Fout bij verwijderen van configuratie',
  'Error updating status': 'Fout bij bijwerken van status',
  '{value}x - Premium': '{value}x - Premie',
  '{value}x - High': '{value}x - Hoog',
  '{value}x - Standard': '{value}x - Standaard',
  'Overtime Configuration': 'Overurenconfiguratie',
  'Manage overtime rates and policies': 'Beheer overurentarieven en -beleid',
  'Loading configurations...': 'Configuraties laden...',
  'Rate Multiplier:': 'Tarieffactor:',
  'Applies To:': 'Van toepassing op:',
  'Day Type:': 'Dagtype:',
  'Time Window:': 'Tijdvenster:',
  'Min Hours:': 'Min. uren:',
  'Max Hours:': 'Max. uren:',
  'Requires Approval:': 'Goedkeuring vereist:',
  'Description:': 'Beschrijving:',
  'No overtime configurations': 'Geen overurenconfiguraties',
  'Edit Overtime Configuration': 'Overurenconfiguratie bewerken',
  'Create Overtime Configuration': 'Overurenconfiguratie aanmaken',
  'Overtime Type *': 'Overurentype *',
  'e.g., Regular Overtime, Weekend Overtime': 'bijv. gewone overuren, weekendoveruren',
  'Code *': 'Code *',
  'e.g., OT_REGULAR': 'bijv. OT_REGULAR',
  'Rate Multiplier *': 'Tarieffactor *',
  '1.5x = time and a half, 2.0x = double time, etc.': '1,5x = anderhalf, 2,0x = dubbel, enz.',
  'Applies To *': 'Van toepassing op *',
  'All Employees': 'Alle werknemers',
  'Hourly Only': 'Alleen per uur',
  'Monthly Only': 'Alleen maandelijks',
  'Day Type *': 'Dagtype *',
  'Any Day': 'Elke dag',
  'Holidays Only': 'Alleen feestdagen',
  'Optional - when overtime period starts': 'Optioneel - wanneer de overurenperiode begint',
  'Optional - when overtime period ends': 'Optioneel - wanneer de overurenperiode eindigt',
  'Minimum Hours': 'Minimumuren',
  'Maximum Hours': 'Maximumuren',
  'Minimum hours to qualify': 'Minimumuren om in aanmerking te komen',
  'Max hours allowed per period': 'Maximale uren per periode',
  'Calculation Order': 'Berekeningsvolgorde',
  'Lower numbers are checked first (0 = highest priority)': 'Lagere nummers worden eerst gecontroleerd (0 = hoogste prioriteit)',
  'Brief description of this overtime type': 'Korte beschrijving van dit overurentype',
  'Requires Approval': 'Goedkeuring vereist',
  'Mandatory': 'Verplicht',
  'Update Configuration': 'Configuratie bijwerken',
  'Create Configuration': 'Configuratie aanmaken',

  // ── Attendance page ─────────────────────────────────────
  '{secs}s ago': '{secs}s geleden',
  '✅ Attendance saved!': '✅ Aanwezigheid opgeslagen!',
  '❌ Error: {message}': '❌ Fout: {message}',
  'Are you sure you want to delete this attendance record?': 'Weet je zeker dat je dit aanwezigheidsrecord wilt verwijderen?',
  '✅Attendance deleted!': '✅ Aanwezigheid verwijderd!',
  'Failed to delete': 'Verwijderen mislukt',
  '✅ Successfully marked {count} attendance records!': '✅ {count} aanwezigheidsrecords succesvol gemarkeerd!',
  'Failed to apply bulk attendance': 'Bulk-aanwezigheid toepassen mislukt',
  '✅ Previous week copied successfully!': '✅ Vorige week succesvol gekopieerd!',
  'Error copying week: {message}': 'Fout bij kopiëren van week: {message}',
  '⚠️ No data to export. Please select an employee with attendance records.': '⚠️ Geen gegevens om te exporteren. Selecteer een werknemer met aanwezigheidsrecords.',
  '✅ Attendance exported successfully!': '✅ Aanwezigheid succesvol geëxporteerd!',
  '⚠️ Percentage must be between 0 and 100': '⚠️ Percentage moet tussen 0 en 100 liggen',
  'Failed to update late deduction: {message}': 'Bijwerken van inhouding te laat mislukt: {message}',
  'Are you sure you want to delete attendance for {date}?\n\nThis action cannot be undone.': 'Weet je zeker dat je de aanwezigheid voor {date} wilt verwijderen?\n\nDeze actie kan niet ongedaan worden gemaakt.',
  '✅ Attendance deleted successfully!': '✅ Aanwezigheid succesvol verwijderd!',
  'Failed to delete: {message}': 'Verwijderen mislukt: {message}',
  'Please enter clock in and clock out times': 'Voer in- en uitkloktijden in',
  '✅ Roster entry updated!': '✅ Roosterregel bijgewerkt!',
  '✅ Roster entry saved!': '✅ Roosterregel opgeslagen!',
  'Attendance Management': 'Aanwezigheidsbeheer',
  'Mark and manage employee attendance': 'Markeer en beheer de aanwezigheid van werknemers',
  'Calendar View': 'Kalenderweergave',
  'Select employee...': 'Selecteer werknemer...',
  'Month:': 'Maand:',
  'Copy Previous Week': 'Vorige week kopiëren',
  'Refresh attendance data': 'Aanwezigheidsgegevens vernieuwen',
  '✨ Updated!': '✨ Bijgewerkt!',
  'Last update: {time}': 'Laatste update: {time}',
  'Auto-refresh every 30s': 'Automatisch vernieuwen elke 30s',
  'Unmarked': 'Niet gemarkeerd',
  'Tip:': 'Tip:',
  'Click on any date to mark attendance': 'Klik op een datum om aanwezigheid te markeren',
  'Select an Employee': 'Selecteer een werknemer',
  'Choose an employee from the dropdown to view and manage their attendance': 'Kies een werknemer in de lijst om de aanwezigheid te bekijken en te beheren',
  'Bulk Attendance Marking': 'Bulk-aanwezigheid markeren',
  'Select multiple employees and dates to mark attendance at once': 'Selecteer meerdere werknemers en datums om aanwezigheid in één keer te markeren',
  'Select Employees ({count} selected)': 'Selecteer werknemers ({count} geselecteerd)',
  'Select All ({count})': 'Alles selecteren ({count})',
  'Select Dates ({count} selected)': 'Selecteer datums ({count} geselecteerd)',
  'Entire Month': 'Hele maand',
  'Set Status & Hours': 'Status en uren instellen',
  'Hours Worked:': 'Gewerkte uren:',
  'Sick Leave': 'Ziekteverlof',
  'Summary': 'Samenvatting',
  'Dates': 'Datums',
  'Apply {count} Records': '{count} records toepassen',
  'Select Employee...': 'Selecteer werknemer...',
  '- SRD {rate}/hr': '- SRD {rate}/uur',
  'Previous Week': 'Vorige week',
  'Next Week': 'Volgende week',
  'Break': 'Pauze',
  'OT Hours': 'OT-uren',
  ' (Total)': ' (Totaal)',
  'min': 'min',
  'Normal': 'Normaal',
  'Normal Hours': 'Normale uren',
  'Sunday Hours': 'Zondaguren',
  'Holiday Hours': 'Feestdaguren',
  'Overtime': 'Overuren',
  'Select an Hourly Employee': 'Selecteer een werknemer per uur',
  'Choose an employee with hourly payment to view their schedule': 'Kies een werknemer met uurbetaling om het rooster te bekijken',
  'Mark Attendance': 'Aanwezigheid markeren',
  'Is Late (Apply Deduction)': 'Is te laat (inhouding toepassen)',
  'Late Minutes *': 'Minuten te laat *',
  'Minutes late': 'Minuten te laat',
  "% to deduct from day's pay": '% in te houden op het dagloon',
  'Overtime Rate (multiplier) *': 'Overurentarief (factor) *',
  '1.5 = 150% (time and a half)': '1,5 = 150% (anderhalf)',
  'Overtime Pay Preview: {hours} hours × {rate}x rate': 'Voorbeeld overurenloon: {hours} uur × {rate}x tarief',
  'Confirm Bulk Operation': 'Bulkactie bevestigen',
  'You are about to create': 'Je staat op het punt om',
  'attendance records:': 'aanwezigheidsrecords aan te maken:',
  'employee(s)': 'werknemer(s)',
  'date(s)': 'datum/data',
  'Hours:': 'Uren:',
  'per day': 'per dag',
  'This will create or overwrite existing records for these dates': 'Dit maakt records aan of overschrijft bestaande records voor deze datums',
  'Fixed rate from employee profile (not editable per shift)': 'Vast tarief uit het werknemersprofiel (niet per dienst te wijzigen)',
  'Break (minutes)': 'Pauze (minuten)',
  'Clock In *': 'Inklokken *',
  'Clock Out *': 'Uitklokken *',
  'Is Sunday (Tax-Free)': 'Is zondag (belastingvrij)',
  'No taxes will be deducted': 'Er worden geen belastingen ingehouden',
  'Pay as Normal Day (1.0x)': 'Uitbetalen als normale dag (1,0x)',
  'Pay with Multiplier': 'Uitbetalen met toeslagfactor',
  '1.5 = time and a half': '1,5 = anderhalf',
  'Is Holiday (Tax-Free)': 'Is feestdag (belastingvrij)',
  '2.0 = double time': '2,0 = dubbel',
  'Enter overtime in minutes (e.g., 30 for 30 minutes)': 'Voer overuren in minuten in (bijv. 30 voor 30 minuten)',
  'Enter overtime in hours (e.g., 1.5 for 1.5 hours)': 'Voer overuren in uren in (bijv. 1,5 voor 1,5 uur)',
  'Overtime Rate *': 'Overurentarief *',
  '1.5 = time and a half, 2.0 = double time': '1,5 = anderhalf, 2,0 = dubbel',
  "Percentage deducted from day's earnings (default 10%)": 'Percentage dat van het dagloon wordt ingehouden (standaard 10%)',
  'Mark as Absent (Apply Deduction)': 'Als afwezig markeren (inhouding toepassen)',
  'Deduction Type': 'Inhoudingstype',
  'Daily Rate (Deduct from this day only)': 'Dagtarief (alleen van deze dag inhouden)',
  'Total Salary (Deduct from full monthly salary)': 'Totaal salaris (inhouden op het volledige maandloon)',
  'Absent Deduction % (0-100)': 'Inhouding afwezigheid % (0-100)',
  'Reason for Absence': 'Reden van afwezigheid',
  'Enter reason for absence...': 'Voer de reden van afwezigheid in...',
  'Mark as Sick Leave': 'Als ziekteverlof markeren',
  'Sick Pay Percentage': 'Ziektegeldpercentage',
  'Employee receives this percentage of their daily pay (default: 75%)': 'De werknemer ontvangt dit percentage van het dagloon (standaard: 75%)',
  'Reason for Sick Leave': 'Reden van ziekteverlof',
  'Enter reason for sick leave (optional)...': 'Voer de reden van ziekteverlof in (optioneel)...',
  'Add notes about this shift...': 'Voeg opmerkingen over deze dienst toe...',
  'Calculation Preview': 'Voorbeeldberekening',
  'Rate:': 'Tarief:',
  'Overtime:': 'Overuren:',
  'Total Amount:': 'Totaalbedrag:',

  // ── Benefits / Deductions / Reports / Admin / Settings extras ──
  'Benefit type created!': 'Toeslagtype aangemaakt!',
  'Error creating benefit type': 'Fout bij aanmaken van toeslagtype',
  'Benefit type updated!': 'Toeslagtype bijgewerkt!',
  'Error updating benefit type': 'Fout bij bijwerken van toeslagtype',
  'Delete this benefit type? This will affect all assignments.': 'Dit toeslagtype verwijderen? Dit heeft gevolgen voor alle toewijzingen.',
  'Benefit type deleted': 'Toeslagtype verwijderd',
  'Error deleting benefit type': 'Fout bij verwijderen van toeslagtype',
  'Benefit assigned successfully!': 'Toeslag succesvol toegewezen!',
  'Error assigning benefit': 'Fout bij toewijzen van toeslag',
  'Benefit updated!': 'Toeslag bijgewerkt!',
  'Error updating benefit': 'Fout bij bijwerken van toeslag',
  'Cancel this benefit?': 'Deze toeslag annuleren?',
  'Benefit cancelled': 'Toeslag geannuleerd',
  'Error cancelling benefit': 'Fout bij annuleren van toeslag',
  'Delete this benefit assignment?': 'Deze toeslagtoewijzing verwijderen?',
  'Benefit deleted': 'Toeslag verwijderd',
  'Error deleting benefit': 'Fout bij verwijderen van toeslag',
  'Benefits Management': 'Beheer van toeslagen',
  'Manage employee benefits and allowances': 'Beheer werknemerstoeslagen en vergoedingen',
  'New Benefit Type': 'Nieuw toeslagtype',
  'Loading benefit types...': 'Toeslagtypen laden...',
  'Code': 'Code',
  'Default Amount': 'Standaardbedrag',
  'Default Percentage (%)': 'Standaardpercentage (%)',
  'Percentage (%)': 'Percentage (%)',
  'Cancelled': 'Geannuleerd',
  'cancelled': 'geannuleerd',
  'Loading benefits...': 'Toeslagen laden...',
  'No benefits assigned yet': 'Nog geen toeslagen toegewezen',
  'Benefit': 'Toeslag',
  'Edit Benefit Type': 'Toeslagtype bewerken',
  'Create Benefit Type': 'Toeslagtype aanmaken',
  'e.g., Health Insurance': 'bijv. Ziektekostenverzekering',
  'e.g., HEALTH_INS': 'bijv. HEALTH_INS',
  'Brief description of the benefit...': 'Korte beschrijving van de toeslag...',
  'Calculation Type': 'Berekeningstype',
  'Fixed Amount': 'Vast bedrag',
  'Percentage': 'Percentage',
  'Active (can be assigned to employees)': 'Actief (kan aan werknemers worden toegewezen)',
  'Assign Benefit to Employee': 'Toeslag toewijzen aan werknemer',
  'Benefit Type': 'Toeslagtype',
  'Select benefit type': 'Selecteer toeslagtype',
  'Percentage (if applicable)': 'Percentage (indien van toepassing)',
  'Edit Benefit Assignment': 'Toeslagtoewijzing bewerken',
  'Update Benefit': 'Toeslag bijwerken',
  'Delete this deduction? This cannot be undone.': 'Deze inhouding verwijderen? Dit kan niet ongedaan worden gemaakt.',
  'Deduction deleted successfully': 'Inhouding succesvol verwijderd',
  'Error deleting deduction': 'Fout bij verwijderen van inhouding',
  'Deductions Management': 'Beheer van inhoudingen',
  'Configure employee deductions': 'Configureer werknemersinhoudingen',
  'Loading deductions...': 'Inhoudingen laden...',
  'No deductions configured': 'Geen inhoudingen geconfigureerd',
  'Deduction Name': 'Naam inhouding',
  'Deduction Code': 'Code inhouding',
  'Deduction': 'Inhouding',
  'Loan': 'Lening',
  'Advance': 'Voorschot',
  'Insurance': 'Verzekering',
  'Default Amount ({currency})': 'Standaardbedrag ({currency})',
  'Payroll takes it when the employee has no amount of their own and is paid in this currency': 'De loonberekening gebruikt het als de werknemer geen eigen bedrag heeft en in deze valuta wordt betaald',
  'each employee needs their own amount': 'elke werknemer heeft een eigen bedrag nodig',
  'Brief description of this deduction': 'Korte beschrijving van deze inhouding',
  'Create Deduction': 'Inhouding aanmaken',
  'deduction': 'inhouding',
  'loan': 'lening',
  'advance': 'voorschot',
  'insurance': 'verzekering',
  'other': 'overig',
  'AM': 'AM',
  'PM': 'PM',
  'Reports & Analytics': 'Rapporten & analyses',
  'Comprehensive business reports and insights': 'Uitgebreide bedrijfsrapporten en inzichten',
  'Loading report...': 'Rapport laden...',
  'days present': 'dagen aanwezig',
  'late arrivals': 'te late aankomsten',
  'absences': 'afwezigheden',
  'Sick/Leave': 'Ziek/verlof',
  'Attendance Details': 'Aanwezigheidsdetails',
  'Late (min)': 'Te laat (min)',
  'h': 'u',
  'No payroll data available': 'Geen salarisgegevens beschikbaar',
  'paid this month': 'deze maand uitbetaald',
  'Total Gross Pay': 'Totaal brutoloon',
  'Total Net Pay': 'Totaal nettoloon',
  'Employee Breakdown': 'Uitsplitsing per werknemer',
  'collected this month': 'deze maand geïnd',
  'Tax Types': 'Belastingtypen',
  'different tax types': 'verschillende belastingtypen',
  'Tax Summary by Type': 'Belastingoverzicht per type',
  'Count': 'Aantal',
  'Tax Details by Employee': 'Belastingdetails per werknemer',
  'No tax data for this period': 'Geen belastinggegevens voor deze periode',
  'Active Benefits': 'Actieve toeslagen',
  'Total Value': 'Totale waarde',
  'per month': 'per maand',
  'receiving benefits': 'ontvangen toeslagen',
  'Active Benefits by Employee': 'Actieve toeslagen per werknemer',
  'No active benefits': 'Geen actieve toeslagen',
  '{count} expenses': '{count} uitgaven',
  'awaiting approval': 'wachtend op goedkeuring',
  'Approved By': 'Goedgekeurd door',
  'No expenses for this period': 'Geen uitgaven voor deze periode',
  'Error loading permissions: {message}': 'Fout bij laden van rechten: {message}',
  'Settings saved successfully!': 'Instellingen succesvol opgeslagen!',
  'Error saving settings': 'Fout bij opslaan van instellingen',
  'Error creating user': 'Fout bij aanmaken van gebruiker',
  'Permissions saved and applied successfully!': 'Rechten succesvol opgeslagen en toegepast!',
  'Permissions saved, but failed to refresh current session. Please log out and log in again to see changes.': 'Rechten opgeslagen, maar de huidige sessie kon niet worden vernieuwd. Log uit en weer in om de wijzigingen te zien.',
  'Permissions saved successfully! Users with this role will see changes on next login.': 'Rechten succesvol opgeslagen! Gebruikers met deze rol zien de wijzigingen bij de volgende login.',
  'Error saving permissions: {message}': 'Fout bij opslaan van rechten: {message}',
  'Error loading the user permissions: {message}': 'Fout bij laden van gebruikersrechten: {message}',
  'Activate this user?': 'Weet je zeker dat je deze gebruiker wilt activeren?',
  'Deactivate this user?': 'Weet je zeker dat je deze gebruiker wilt deactiveren?',
  'User activated!': 'Gebruiker succesvol geactiveerd!',
  'User deactivated!': 'Gebruiker succesvol gedeactiveerd!',
  'Error updating the status: {message}': 'Fout bij bijwerken van status: {message}',
  'Fill in both password fields': 'Vul beide wachtwoordvelden in',
  'The passwords do not match': 'De wachtwoorden komen niet overeen',
  'The password must be at least 8 characters': 'Het wachtwoord moet minstens 8 tekens bevatten',
  'Password changed!': 'Wachtwoord succesvol gewijzigd!',
  'Error changing the password: {message}': 'Fout bij wijzigen van wachtwoord: {message}',
  'Error deleting the user: {message}': 'Fout bij verwijderen van gebruiker: {message}',
  'Error updating the role: {message}': 'Fout bij bijwerken van rol: {message}',
  'Access Denied': 'Toegang geweigerd',
  'Super Admin Panel': 'Superbeheerderspaneel',
  'You have unsaved changes': 'Je hebt niet-opgeslagen wijzigingen',
  'Save All Changes': 'Alle wijzigingen opslaan',
  'You have unsaved permission changes': 'Je hebt niet-opgeslagen rechtenwijzigingen',
  'No description': 'Geen beschrijving',
  'User Management': 'Gebruikersbeheer',
  'Created': 'Aangemaakt',
  'No users found': 'Geen gebruikers gevonden',
  'Deactivate user': 'Gebruiker deactiveren',
  'Activate user': 'Gebruiker activeren',
  'Change password': 'Wachtwoord wijzigen',
  'Delete user': 'Gebruiker verwijderen',
  'Edit individual permissions': 'Individuele rechten bewerken',
  'Permissions': 'Rechten',
  'Role Permissions': 'Rolrechten',
  'Select Role': 'Selecteer rol',
  'Loading permissions for {role}...': 'Rechten laden voor {role}...',
  'No permissions found for {role}': 'Geen rechten gevonden voor {role}',
  'Resource': 'Bron',
  'Today': 'Vandaag',
  'This Week': 'Deze week',
  'Action': 'Actie',
  'No activity logs found': 'Geen activiteitenlogboeken gevonden',
  'System Statistics': 'Systeemstatistieken',
  'Loading statistics...': 'Statistieken laden...',
  'Users & Authentication': 'Gebruikers & authenticatie',
  'Active Users': 'Actieve gebruikers',
  'Unique Roles': 'Unieke rollen',
  'Create New User': 'Nieuwe gebruiker aanmaken',
  'Create User': 'Gebruiker aanmaken',
  'Confirm Password': 'Bevestig wachtwoord',
  'Change Password': 'Wachtwoord wijzigen',
  'Are you sure you want to delete {name}?': 'Weet je zeker dat je {name} wilt verwijderen?',
  'Delete User': 'Gebruiker verwijderen',
  'Individual Permissions': 'Individuele rechten',
  '{name} (overrides the role)': '{name} (overschrijft rol)',
  'dashboard': 'dashboard',
  'employees': 'werknemers',
  'attendance': 'aanwezigheid',
  'leaves': 'verlof',
  'payroll': 'salaris',
  'finance': 'financiën',
  'benefits': 'toeslagen',
  'contracts': 'contracten',
  'documents': 'documenten',
  'reports': 'rapporten',
  'settings': 'instellingen',
  'Error loading overtime tax brackets': 'Fout bij laden van overurenbelastingschijven',
  'Error saving tax bracket': 'Fout bij opslaan van belastingschijf',
  'Delete this tax bracket? This cannot be undone.': 'Deze belastingschijf verwijderen? Dit kan niet ongedaan worden gemaakt.',
  'Error deleting tax bracket': 'Fout bij verwijderen van belastingschijf',
  '📊 Overtime Tax Configuration': '📊 Configuratie overurenbelasting',
  'Manage tax brackets for overtime earnings (Belasting Overuren)': 'Beheer belastingschijven voor overuren (Belasting Overuren)',
  'Loading tax brackets...': 'Belastingschijven laden...',
  'Min Amount': 'Minimumbedrag',
  'Max Amount': 'Maximumbedrag',
  'No overtime tax brackets configured': 'Geen overurenbelastingschijven geconfigureerd',
  '✏️ Edit Tax Bracket': '✏️ Belastingschijf bewerken',
  '➕ Create Tax Bracket': '➕ Belastingschijf aanmaken',
  'Bracket Name': 'Schijfnaam',
  'e.g., Bracket 1': 'bijv. Schijf 1',
  'Tax Rate (%)': 'Belastingtarief (%)',
  'Enter as percentage (e.g., 5 for 5%, 15 for 15%)': 'Voer in als percentage (bijv. 5 voor 5%, 15 voor 15%)',
  'Min Amount (SRD)': 'Minimumbedrag (SRD)',
  'Max Amount (SRD)': 'Maximumbedrag (SRD)',
  'Leave empty for unlimited': 'Leeg laten voor onbeperkt',
  'Leave empty for highest bracket': 'Leeg laten voor de hoogste schijf',
  'Brief description of this tax bracket': 'Korte beschrijving van deze belastingschijf',
  'Update Bracket': 'Schijf bijwerken',
  'Create Bracket': 'Schijf aanmaken',
  '📝 Leave Requests': '📝 Verlofaanvragen',
  '💰 Payroll': '💰 Salarisadministratie',
  '💳 Finance': '💳 Financiën',
  '⏰ Overtime': '⏰ Overuren',
  '📁 Documents': '📁 Documenten',
  '👤 Employee Changes': '👤 Werknemerswijzigingen',
  'Expense Pending Approval': 'Uitgave wacht op goedkeuring',
  'Expense Approved': 'Uitgave goedgekeurd',
  'Expense Rejected': 'Uitgave afgewezen',
  'Budget Alert': 'Budgetwaarschuwing',
  'Document Uploaded': 'Document geüpload',
  'Document Expiring': 'Document verloopt',
  'Employee Changes': 'Werknemerswijzigingen',
  'Loading notification preferences...': 'Meldingsvoorkeuren laden...',
  '🔔 Notification Settings': '🔔 Meldingsinstellingen',
  'Configure which notifications you want to receive': 'Stel in welke meldingen je wilt ontvangen',
  '💾 Save Notification Preferences': '💾 Meldingsvoorkeuren opslaan',
  'Failed to delete bracket': 'Schijf verwijderen mislukt',
  'Failed to test calculation': 'Testberekening mislukt',
  'Error loading settings': 'Fout bij laden van instellingen',
  '✅ Loonbelasting configuration updated successfully!': '✅ Loonbelastingconfiguratie succesvol bijgewerkt!',
  'Error loading Loonbelasting configuration': 'Fout bij het laden van de loonbelastingconfiguratie',
  'Create the {to} configuration with the values of {from}?': 'De configuratie voor {to} aanmaken met de waarden van {from}?',
  '{year} created. Check its values and save.': '{year} aangemaakt. Controleer de waarden en sla op.',
  'Fill in every amount before saving': 'Vul alle bedragen in voordat u opslaat',
  'Loonbelasting {year} saved': 'Loonbelasting {year} opgeslagen',
  'Copy {from} to {to}': '{from} kopiëren naar {to}',
  'There is no configuration for {year}: payroll for periods ending in {year} cannot be calculated. Copy the last year to create it.': 'Er is geen configuratie voor {year}: loonberekeningen voor perioden die in {year} eindigen, kunnen niet worden uitgevoerd. Kopieer het laatste jaar om haar aan te maken.',
  'There is no configuration for {year} yet: create it before January.': 'Er is nog geen configuratie voor {year}: maak haar vóór januari aan.',
  'No Loonbelasting configuration exists.': 'Er bestaat geen loonbelastingconfiguratie.',
  'Saved, except settings that do not exist: {keys}': 'Opgeslagen, behalve instellingen die niet bestaan: {keys}',
  'Error loading payroll settings': 'Fout bij het laden van de looninstellingen',
  'Check {field}: it must be between {min} and {max}': 'Controleer {field}: het moet tussen {min} en {max} liggen',
  'Payroll settings saved': 'Looninstellingen opgeslagen',
  'Payroll reads these values. Saving applies them to the next calculation.': 'De loonberekening gebruikt deze waarden. Opslaan geldt vanaf de volgende berekening.',
  'From 1 to 5 (1.5 = 150% of the hourly rate)': 'Van 1 tot 5 (1,5 = 150% van het uurloon)',
  'From 1 to 5 (2.0 = 200% of the hourly rate)': 'Van 1 tot 5 (2,0 = 200% van het uurloon)',
  'Used to prorate monthly salaries (1 to 31)': 'Gebruikt om maandsalarissen naar rato te berekenen (1 tot 31)',
  'Hours per Day': 'Uren per dag',
  'A working day for daily rates and paid leave (up to 24)': 'Een werkdag voor dagtarieven en betaald verlof (tot 24)',
  'Sick Pay (%)': 'Ziekengeld (%)',
  'Share of the pay for a sick day (0 to 100)': 'Deel van het loon voor een ziektedag (0 tot 100)',
  'Save Payroll Settings': 'Looninstellingen opslaan',
  'Error loading the overtime tax': 'Fout bij het laden van de overurenbelasting',
  'Frozen: pending the client\'s decision. Read-only.': 'Bevroren: in afwachting van het besluit van de klant. Alleen-lezen.',
  'Payroll applies these brackets to overtime pay (database function calculate_overtime_tax):': 'De loonberekening past deze schijven toe op overurenloon (databasefunctie calculate_overtime_tax):',
  'From (SRD)': 'Van (SRD)',
  'To (SRD)': 'Tot (SRD)',
  'and above': 'en hoger',
  'What the function returns': 'Wat de functie teruggeeft',
  'Overtime gross (SRD)': 'Bruto overuren (SRD)',
  'Overtime tax (SRD)': 'Overurenbelasting (SRD)',
  'Progressive tax on overtime pay': 'Progressieve belasting op overurenloon',
  'Loonbelasting is set per year in Tax Configuration, with its brackets and exemptions.': 'Loonbelasting wordt per jaar ingesteld in Belastingconfiguratie, met de schijven en vrijstellingen.',
  'The brackets of {year} are those of Loonbelasting (LB_SRD) below: edit them there with this year selected.': 'De schijven van {year} zijn die van Loonbelasting (LB_SRD) hieronder: bewerk ze daar met dit jaar geselecteerd.',
  'Create {to} with the Loonbelasting parameters, brackets and exemptions of {from}?': '{to} aanmaken met de loonbelastingparameters, schijven en vrijstellingen van {from}?',
  'Brackets for {year}': 'Schijven voor {year}',
  'Error loading tax exemptions': 'Fout bij het laden van de belastingvrijstellingen',
  'The percentage must be between 0 and 100': 'Het percentage moet tussen 0 en 100 liggen',
  'An exempt earning needs a percentage above 0': 'Een vrijgestelde inkomst heeft een percentage boven 0 nodig',
  'Exemption saved': 'Vrijstelling opgeslagen',
  'Error saving the exemption': 'Fout bij het opslaan van de vrijstelling',
  'Tax exemptions {year}': 'Belastingvrijstellingen {year}',
  'Earnings marked exempt stay out of the Loonbelasting and AOV base, by the percentage shown.': 'Vrijgestelde inkomsten blijven, voor het getoonde percentage, buiten de grondslag van loonbelasting en AOV.',
  'Earning': 'Inkomst',
  'Exempt': 'Vrijgesteld',
  'Exempt %': 'Vrijgesteld %',
  'Exempt {type}': '{type} vrijgesteld',
  'Exempt % of {type}': 'Vrijgesteld % van {type}',
  'Failed to save configuration': 'Configuratie opslaan mislukt',
  '✅ Loonbelasting bracket saved successfully!': '✅ Loonbelastingschijf succesvol opgeslagen!',
  'Delete this Loonbelasting tax bracket?': 'Deze Loonbelastingschijf verwijderen?',
  '✅ Loonbelasting bracket deleted!': '✅ Loonbelastingschijf verwijderd!',
  '✅ Tax bracket deleted!': '✅ Belastingschijf verwijderd!',
  'Company Name': 'Bedrijfsnaam',
  'Regional Settings': 'Regionale instellingen',
  'DOP - Dominican Peso': 'DOP - Dominicaanse peso',
  'Timezone': 'Tijdzone',
  'Date Format': 'Datumnotatie',
  'Loonbelasting Configuration (Suriname Wage Tax)': 'Loonbelastingconfiguratie (Surinaamse loonbelasting)',
  "Configure parameters for Suriname's progressive wage tax calculation (Year {year})": 'Configureer parameters voor de progressieve loonbelasting van Suriname (jaar {year})',
  'Forfaitaire Aftrek (Forfait Deduction)': 'Forfaitaire aftrek',
  'Forfait Percentage (%)': 'Forfaitpercentage (%)',
  'Percentage of gross salary (default: 4%)': 'Percentage van het brutoloon (standaard: 4%)',
  'Maximum Forfait Amount (SRD)': 'Maximum forfaitbedrag (SRD)',
  'Maximum deduction amount (default: 400)': 'Maximumaftrek (standaard: 400)',
  'Formula': 'Formule',
  'Belastingvrije Som (Tax-Free Amount)': 'Belastingvrije som',
  'Tax-Free Base Amount (SRD)': 'Belastingvrij basisbedrag (SRD)',
  'Income below this amount is not taxed (default: 9,000)': 'Inkomen onder dit bedrag wordt niet belast (standaard: 9.000)',
  'Taxable Income': 'Belastbaar inkomen',
  'AOV (Old Age Insurance)': 'AOV (ouderdomsverzekering)',
  'AOV Percentage (%)': 'AOV-percentage (%)',
  'Old age insurance percentage (default: 4%)': 'Percentage ouderdomsverzekering (standaard: 4%)',
  'Optional notes about this configuration...': 'Optionele opmerkingen over deze configuratie...',
  'Save Loonbelasting Configuration': 'Loonbelastingconfiguratie opslaan',
  'Progressive Tax Brackets (Editable)': 'Progressieve belastingschijven (bewerkbaar)',
  'Progressive Tax Brackets': 'Progressieve belastingschijven',
  'Payroll uses the brackets of Loonbelasting (LB_SRD) in Tax Configuration. Edit them there.': 'De salarisberekening gebruikt de schijven van Loonbelasting (LB_SRD) in Belastingconfiguratie. Pas ze daar aan.',
  'Open Tax Configuration': 'Belastingconfiguratie openen',
  'Configure the tax rates for each income bracket': 'Stel de belastingtarieven per inkomensschijf in',
  'Add Bracket': 'Schijf toevoegen',
  'Bracket': 'Schijf',
  'Range (SRD)': 'Bereik (SRD)',
  'No brackets configured. Click "Add Bracket" to create one.': 'Geen schijven geconfigureerd. Klik op "Schijf toevoegen" om er een aan te maken.',
  'Test Calculator': 'Testcalculator',
  'Gross Pay (SRD)': 'Brutoloon (SRD)',
  'Enter gross salary (e.g., 18000)': 'Voer brutoloon in (bijv. 18000)',
  'Calculation Result for SRD {amount}': 'Berekeningsresultaat voor SRD {amount}',
  '- Forfait Aftrek ({pct}%, max {max}):': '- Forfait aftrek ({pct}%, max {max}):',
  'Loon na Aftrek': 'Loon na aftrek',
  'Tax-Free Amount': 'Belastingvrij bedrag',
  'Belastbaar Inkomen (Taxable)': 'Belastbaar inkomen',
  'Loonbelasting (Progressive Tax)': 'Loonbelasting (progressieve belasting)',
  'AOV ({pct}%):': 'AOV ({pct}%):',
  'Effective Tax Rate': 'Effectief belastingtarief',
  'Overtime Tax Configuration (Belasting Overuren)': 'Configuratie overurenbelasting (Belasting Overuren)',
  'Configure progressive tax brackets for overtime earnings': 'Stel progressieve belastingschijven voor overuren in',
  'No tax brackets configured. Click "Add Tax Bracket" to create one.': 'Geen belastingschijven geconfigureerd. Klik op "Belastingschijf toevoegen" om er een aan te maken.',
  'Test Overtime Tax Calculator': 'Testcalculator overurenbelasting',
  'Overtime Gross (SRD)': 'Bruto overuren (SRD)',
  'Enter overtime gross (e.g., 976.56)': 'Voer bruto overuren in (bijv. 976,56)',
  'Overtime Gross': 'Bruto overuren',
  'Overtime Tax ({bracket}):': 'Overurenbelasting ({bracket}):',
  'Overtime Net': 'Netto overuren',
  '✏️ Edit Loonbelasting Bracket': '✏️ Loonbelastingschijf bewerken',
  '➕ Create Loonbelasting Bracket': '➕ Loonbelastingschijf aanmaken',
  'e.g., Bracket 1 - Tax Free': 'bijv. Schijf 1 - belastingvrij',
  'Enter as percentage (e.g., 0 for tax-free, 8 for 8%, 18 for 18%)': 'Voer in als percentage (bijv. 0 voor belastingvrij, 8 voor 8%, 18 voor 18%)',
  'Optional description': 'Optionele beschrijving',
  'Payroll Settings': 'Salarisinstellingen',
  'Payroll Period': 'Salarisperiode',
  'Bi-Weekly': 'Tweewekelijks',
  'Working Days Per Month': 'Werkdagen per maand',
  'Overtime Rate (multiplier)': 'Overurentoeslag (factor)',
  'Sunday & Holiday Premium Pay': 'Zondag- en feestdagenteoslag',
  'Enable Sunday Premium Pay': 'Zondagtoeslag inschakelen',
  'Current: {rate}x (e.g., 1.5 = 150% of regular rate)': 'Huidig: {rate}x (bijv. 1,5 = 150% van het normale tarief)',
  'Enable Holiday Premium Pay': 'Feestdagenteoslag inschakelen',
  'Current: {rate}x (e.g., 2.0 = 200% of regular rate)': 'Huidig: {rate}x (bijv. 2,0 = 200% van het normale tarief)',
  'Note: these rates apply only to employees who do not have their own multiplier set on their profile. An employee-level value always takes precedence over this default.': 'Let op: deze tarieven gelden alleen voor werknemers zonder eigen factor op hun profiel. Een waarde op werknemersniveau gaat altijd voor op deze standaard.',
  '💾 Save Premium Configuration': '💾 Premieconfiguratie opslaan',
  'Work Hours Settings': 'Instellingen werkuren',
  'Max Hours per Day': 'Max. uren per dag',
  'Max Hours per Week': 'Max. uren per week',
  'Vacation Days per Year': 'Vakantiedagen per jaar',
  'Sick Leave Days per Year': 'Ziektedagen per jaar',
  'Percentage of daily pay for sick days (0-100%)': 'Percentage van het dagloon voor ziektedagen (0-100%)',
  '💊 Currently: {pct}% (Employee receives this percentage when on sick leave)': '💊 Momenteel: {pct}% (werknemer ontvangt dit percentage bij ziekteverlof)',
  'Automation Settings': 'Automatiseringsinstellingen',
  'Auto-approve attendance records': 'Aanwezigheidsrecords automatisch goedkeuren',
  'Auto-calculate overtime': 'Overuren automatisch berekenen',
  'Session Timeout (minutes)': 'Sessietime-out (minuten)',
  '5 minutes': '5 minuten',
  '10 minutes': '10 minuten',
  '15 minutes': '15 minuten',
  '30 minutes': '30 minuten',
  '60 minutes': '60 minuten',
  '2 hours': '2 uur',
  'Automatically logout after this period of inactivity': 'Automatisch uitloggen na deze periode van inactiviteit',
  'Save General Settings': 'Algemene instellingen opslaan',
  'Loonbelasting Tax Brackets (Editable)': 'Loonbelastingschijven (bewerkbaar)',
  'Configure progressive tax brackets for Suriname wage tax (Year {year})': 'Stel progressieve belastingschijven in voor de Surinaamse loonbelasting (jaar {year})',
  'No Loonbelasting tax brackets configured. Click "Add Tax Bracket" to create one.': 'Geen Loonbelastingschijven geconfigureerd. Klik op "Belastingschijf toevoegen" om er een aan te maken.',
  'How Loonbelasting Works': 'Hoe Loonbelasting werkt',
  'Loonbelasting uses a': 'Loonbelasting gebruikt een',
  'progressive tax system': 'progressief belastingstelsel',
  'Each bracket is applied to the portion of income that falls within that range:': 'Elke schijf wordt toegepast op het deel van het inkomen dat binnen dat bereik valt:',
  'Step 1': 'Stap 1',
  'Step 2': 'Stap 2',
  'Step 3': 'Stap 3',
  'Step 4': 'Stap 4',
  'Apply progressive brackets to Taxable Income': 'Pas progressieve schijven toe op het belastbaar inkomen',
  'Add AOV (calculated separately on Loon na Aftrek)': 'Voeg AOV toe (apart berekend over Loon na aftrek)',
  'Example': 'Voorbeeld',
  'If taxable income is SRD 12,000 with brackets [0-9K @ 0%, 9K-18K @ 8%]:': 'Als het belastbaar inkomen SRD 12.000 is met schijven [0-9K @ 0%, 9K-18K @ 8%]:',
  'First SRD 9,000: SRD 0 (0%)': 'Eerste SRD 9.000: SRD 0 (0%)',
  'Next SRD 3,000: SRD 240 (8%)': 'Volgende SRD 3.000: SRD 240 (8%)',
  'Test Loonbelasting Brackets Calculator': 'Testcalculator Loonbelastingschijven',
  '📋 Progressive Tax Calculation for SRD {amount}': '📋 Progressieve belastingberekening voor SRD {amount}',
  'Progressive Loonbelasting Tax': 'Progressieve Loonbelasting',
  'Net Pay (after tax)': 'Nettoloon (na belasting)',
  'Brackets Used': 'Gebruikte schijven',
  'Range': 'Bereik',
  "Optional description (e.g., 'First 9,000 is tax-free')": "Optionele beschrijving (bijv. 'Eerste 9.000 is belastingvrij')",

  // ── Payroll / Finance / Tax / PDF / Excel (this batch) ──
  'Error approving payroll': 'Fout bij goedkeuren van salaris',
  'Error rejecting payroll': 'Fout bij afwijzen van salaris',
  'Are you sure you want to delete this payroll record?': 'Weet je zeker dat je dit salarisrecord wilt verwijderen?',
  'Payroll record deleted': 'Salarisrecord verwijderd',
  'Error deleting payroll': 'Fout bij verwijderen van salaris',
  'File exported': 'Bestand succesvol geëxporteerd',
  'Error exporting the file': 'Fout bij exporteren van bestand',
  'Payroll Management': 'Salarisbeheer',
  'Calculate and manage employee payments': 'Bereken en beheer werknemersbetalingen',
  'Create Individual Payroll': 'Individueel salaris aanmaken',
  '{count} employees': '{count} werknemers',
  'Bulk Calculate': 'Bulk berekenen',
  'Bulk Payroll Calculation': 'Bulk salarisberekening',
  'Calculate payroll for multiple employees at once for a specific period.': 'Bereken het salaris voor meerdere werknemers tegelijk voor een bepaalde periode.',
  'Period Start Date *': 'Startdatum periode *',
  'Period End Date *': 'Einddatum periode *',
  'Employee (Optional)': 'Werknemer (optioneel)',
  'All Active Employees': 'Alle actieve werknemers',
  'Leave empty to calculate for all active employees': 'Laat leeg om voor alle actieve werknemers te berekenen',
  'Manual Payroll Calculator': 'Handmatige salariscalculator',
  'Calculate payroll for one or multiple employees with full control over taxes and deductions.': 'Bereken het salaris voor één of meerdere werknemers met volledige controle over belastingen en inhoudingen.',
  'Open Payroll Calculator': 'Salariscalculator openen',
  'No active employees found. Please add employees first.': 'Geen actieve werknemers gevonden. Voeg eerst werknemers toe.',
  'Filter Payroll Records by Period': 'Salarisrecords filteren op periode',
  'Apply Filter': 'Filter toepassen',
  'Loading payroll records...': 'Salarisrecords laden...',
  'No payroll records found for the selected period.': 'Geen salarisrecords gevonden voor de geselecteerde periode.',
  'Period': 'Periode',
  'Days/Hours': 'Dagen/uren',
  'Until': 'Tot',
  'OT': 'OT',
  'days': 'dagen',
  'Download PDF': 'PDF downloaden',
  'Approve Payroll': 'Salaris goedkeuren',
  'Payroll Details': 'Salarisgegevens',
  'Period:': 'Periode:',
  'Net Pay:': 'Nettoloon:',
  'Payment Method *': 'Betaalmethode *',
  'Payment Date *': 'Betaaldatum *',
  'Approve Payment': 'Betaling goedkeuren',
  'Reject Payroll': 'Salaris afwijzen',
  'Please provide a reason...': 'Geef een reden op...',
  'Employee Information': 'Werknemersgegevens',
  'Payment Type:': 'Betaalwijze:',
  'Pay Period': 'Loonperiode',
  'Payment Date:': 'Betaaldatum:',
  'Work Details': 'Werkgegevens',
  'Hours Worked:': 'Gewerkte uren:',
  'hours': 'uur',
  'Overtime Pay:': 'Overurenloon:',
  'Days Worked:': 'Gewerkte dagen:',
  'Calculation:': 'Berekening:',
  'Prorated ({worked}/30 days)': 'Naar rato ({worked}/30 dagen)',
  'Full Month (30 days)': 'Hele maand (30 dagen)',
  'Earnings': 'Verdiensten',
  'Bonuses': 'Bonussen',
  'Overtime Pay': 'Overurenloon',
  'Taxes Breakdown': 'Belastingoverzicht',
  'Income Tax': 'Inkomstenbelasting',
  'NET PAY': 'NETTOLOON',
  'Employee ID {id} not found': 'Werknemer-ID {id} niet gevonden',
  'No attendance records found': 'Geen aanwezigheidsrecords gevonden',
  'No salary calculated (possibly no work days)': 'Geen salaris berekend (mogelijk geen werkdagen)',
  'Invalid data or no attendance records': 'Ongeldige gegevens of geen aanwezigheidsrecords',
  'Some employees were skipped:': 'Sommige werknemers zijn overgeslagen:',
  'Successfully calculated {count} payroll(s)': '{count} salaris(sen) succesvol berekend',
  'No payrolls could be calculated': 'Er konden geen salarissen worden berekend',
  'No payroll previews could be generated.': 'Er konden geen salarisvoorbeelden worden gegenereerd.',
  'Possible reasons:': 'Mogelijke redenen:',
  '• No attendance records for the selected period': '• Geen aanwezigheidsrecords voor de geselecteerde periode',
  '• No worked days/hours recorded': '• Geen gewerkte dagen/uren geregistreerd',
  '• Invalid employee data': '• Ongeldige werknemersgegevens',
  'Please check the attendance records and try again.': 'Controleer de aanwezigheidsrecords en probeer het opnieuw.',
  'Error calculating payroll:': 'Fout bij berekenen van salaris:',
  'Are you sure you want to create {count} payroll record(s)?': 'Weet je zeker dat je {count} salarisrecord(s) wilt aanmaken?',
  'Successfully created {count} payroll record(s)!': '{count} salarisrecord(s) succesvol aangemaakt!',
  'Errors:': 'Fouten:',
  'Failed to create payroll records:': 'Aanmaken van salarisrecords mislukt:',
  'Error saving payroll records': 'Fout bij opslaan van salarisrecords',
  'Payroll Calculator': 'Salariscalculator',
  'Calculate and review employee payroll': 'Bereken en controleer het werknemerssalaris',
  'Select & Configure': 'Selecteren en configureren',
  'Review & Adjust': 'Controleren en aanpassen',
  'Select Employees': 'Werknemers selecteren',
  'Deselect Page': 'Pagina deselecteren',
  'Select Page': 'Pagina selecteren',
  'Search by name, position, department, or ID...': 'Zoek op naam, functie, afdeling of ID...',
  'All Departments': 'Alle afdelingen',
  'Showing {from}-{to} of {total} employees': '{from}-{to} van {total} werknemers weergegeven',
  '(filtered from {count} total)': '(gefilterd uit {count} totaal)',
  '← Previous': '← Vorige',
  'Page {current} of {total}': 'Pagina {current} van {total}',
  'Next →': 'Volgende →',
  'employee(s) selected': 'werknemer(s) geselecteerd',
  'Calculate for {count} Employee(s)': 'Berekenen voor {count} werknemer(s)',
  'Total Gross': 'Totaal bruto',
  'min Late': 'min te laat',
  'Worked {worked} of {expected} expected days ({pct}%)': '{worked} van {expected} verwachte dagen gewerkt ({pct}%)',
  'Gross': 'Bruto',
  'Attendance & Work Summary': 'Aanwezigheid en werksamenvatting',
  'Days Worked': 'Gewerkte dagen',
  'Work Ratio': 'Werkverhouding',
  'Base Salary': 'Basissalaris',
  'Earnings Breakdown': 'Overzicht verdiensten',
  'Component': 'Onderdeel',
  'Premium': 'Toeslag',
  'hrs': 'uur',
  'hr': 'uur',
  '💰 Tax Breakdown (Editable)': '💰 Belastingoverzicht (bewerkbaar)',
  'Rate (%)': 'Tarief (%)',
  'Effective rate: {rate}% (calculated from brackets)': 'Effectief tarief: {rate}% (berekend uit schijven)',
  'Editable tax rate': 'Bewerkbaar belastingtarief',
  '➕ Add Tax': '➕ Belasting toevoegen',
  '📋 Deductions (Editable)': '📋 Inhoudingen (bewerkbaar)',
  'Enter deduction name:': 'Naam van inhouding invoeren:',
  'Enter amount:': 'Bedrag invoeren:',
  '➕ Add Custom Deduction': '➕ Aangepaste inhouding toevoegen',
  'Deductions and adjustments': 'Inhoudingen en correcties',
  'Adjustment: added': 'Correctie: bijgeteld',
  'Adjustment: deducted': 'Correctie: ingehouden',
  'Remove adjustment': 'Correctie verwijderen',
  'Adjustment type': 'Soort correctie',
  'Deduct from net pay': 'Inhouden op nettoloon',
  'Add to net pay': 'Bijtellen bij nettoloon',
  'Adjustment description': 'Omschrijving van de correctie',
  'What (e.g. uniform not returned)': 'Wat (bijv. uniform niet ingeleverd)',
  'Adjustment amount': 'Bedrag van de correctie',
  'Adjustment reason': 'Reden van de correctie',
  'Reason (saved with your name)': 'Reden (wordt met uw naam opgeslagen)',
  'Add adjustment': 'Correctie toevoegen',
  'Adjustments are applied after tax. Something that should be taxed, like a bonus, is a benefit.': 'Correcties gelden na belasting. Iets dat belast moet worden, zoals een bonus, is een toeslag.',
  'Write what the adjustment is': 'Schrijf wat de correctie is',
  'The amount must be a positive number with at most 2 decimals': 'Het bedrag moet een positief getal zijn met hoogstens 2 decimalen',
  'Write the reason for the adjustment': 'Schrijf de reden van de correctie',
  'Payroll was not saved': 'Salarisberekening is niet opgeslagen',
  '{pct}% of gross pay': '{pct}% van het brutoloon',
  '← Back to Selection': '← Terug naar selectie',
  'Error loading payrolls: {error}': 'Fout bij laden van salarissen: {error}',
  'Error loading consolidations: {error}': 'Fout bij laden van consolidaties: {error}',
  'Error loading details: {error}': 'Fout bij laden van details: {error}',
  'Available Payrolls': 'Beschikbare salarissen',
  'Exported successfully!': 'Succesvol geëxporteerd!',
  'No data to export': 'Geen gegevens om te exporteren',
  'Error exporting: {error}': 'Fout bij exporteren: {error}',
  'Total Net': 'Totaal netto',
  'Consolidations': 'Consolidaties',
  'Consolidation': 'Consolidatie',
  'Please select at least one payroll': 'Selecteer minstens één salaris',
  'Create consolidation with {count} payroll(s)?': 'Consolidatie aanmaken met {count} salaris(sen)?',
  'Consolidation created on {date}': 'Consolidatie aangemaakt op {date}',
  'Consolidation created successfully!': 'Consolidatie succesvol aangemaakt!',
  'Error: {error}': 'Fout: {error}',
  'Consolidation marked as paid!': 'Consolidatie als betaald gemarkeerd!',
  'Enter reason for cancelling consolidation {code}:': 'Voer een reden in voor het annuleren van consolidatie {code}:',
  'Consolidation cancelled and payrolls reverted!': 'Consolidatie geannuleerd en salarissen teruggezet!',
  'Consolidate and process payroll payments': 'Consolideer en verwerk salarisbetalingen',
  'Pending Payment': 'In afwachting van betaling',
  'Paid': 'Betaald',
  'Create Consolidation': 'Consolidatie aanmaken',
  'Enter department...': 'Afdeling invoeren...',
  'Apply Filters': 'Filters toepassen',
  'Available Payrolls ({count})': 'Beschikbare salarissen ({count})',
  'No Approved Payrolls Available': 'Geen goedgekeurde salarissen beschikbaar',
  'All approved payrolls have been consolidated or there are no approved payrolls for the selected period.': 'Alle goedgekeurde salarissen zijn geconsolideerd of er zijn geen goedgekeurde salarissen voor de geselecteerde periode.',
  'Selected Summary': 'Samenvatting selectie',
  'Payrolls:': 'Salarissen:',
  'Total Gross:': 'Totaal bruto:',
  'Total Deductions:': 'Totaal inhoudingen:',
  'Total Net Pay:': 'Totaal nettoloon:',
  'Consolidation History ({count})': 'Consolidatiegeschiedenis ({count})',
  'No Consolidations Yet': 'Nog geen consolidaties',
  'Create your first consolidation from the "Create Consolidation" tab.': 'Maak je eerste consolidatie aan via het tabblad "Consolidatie aanmaken".',
  'Mark as Paid': 'Als betaald markeren',
  'Consolidation Details': 'Consolidatiegegevens',
  'Export Details': 'Details exporteren',
  'Code:': 'Code:',
  'Total Net:': 'Totaal netto:',
  'Employees:': 'Werknemers:',
  'Included Payrolls': 'Opgenomen salarissen',
  'Net': 'Netto',
  'Consolidation:': 'Consolidatie:',
  'Amount:': 'Bedrag:',
  'Payment Reference': 'Betalingskenmerk',
  'e.g., Bank transfer #12345': 'bijv. bankoverschrijving #12345',
  'pending payment': 'in afwachting van betaling',
  'Payroll Count': 'Aantal salarissen',
  'Consolidation Code': 'Consolidatiecode',
  'Payroll Status': 'Salarisstatus',
  'Created At': 'Aangemaakt op',
  'Created By': 'Aangemaakt door',
  'ID': 'ID',
  'Absent Days:': 'Afwezige dagen:',
  'EARNINGS': 'ONTVANGEN',
  'GROSS PAY': 'LOON',
  'OVERTIME': 'OVER UUR',
  'BONUS': 'BONUS',
  'TOTAL EARNINGS': 'TOTAAL ONTVANGEN',
  'TAXES': 'BELASTINGEN',
  'TAX': 'BELASTING',
  'TOTAL TAXES': 'TOTAAL BELASTINGEN',
  'DEDUCTIONS': 'INHOUDINGEN',
  'TOTAL DEDUCTIONS': 'TOTAAL INHOUDINGEN',
  'Generated on:': 'Gegenereerd op:',
  'Salary/Rate': 'Salaris/tarief',
  'Income': 'Inkomsten',
  'Indefinite': 'Onbepaald',
  'Signature Date': 'Datum ondertekening',
  'Value': 'Waarde',
  'Frequency': 'Frequentie',
  'General': 'Algemeen',
  'File Type': 'Bestandstype',
  'Size (KB)': 'Grootte (KB)',
  'Upload Date': 'Uploaddatum',
  'Uploaded By': 'Geüpload door',
  'Requested On': 'Aangevraagd op',
  'Approval Date': 'Goedkeuringsdatum',
  'Expense created successfully!': 'Uitgave succesvol aangemaakt!',
  'Error creating expense': 'Fout bij aanmaken van uitgave',
  'Expense updated!': 'Uitgave bijgewerkt!',
  'Error updating expense': 'Fout bij bijwerken van uitgave',
  'Receipt uploaded!': 'Bon geüpload!',
  'Error uploading receipt': 'Fout bij uploaden van bon',
  'Error downloading receipt': 'Fout bij downloaden van bon',
  'Approve this expense?': 'Deze uitgave goedkeuren?',
  'Expense approved!': 'Uitgave goedgekeurd!',
  'Error approving expense': 'Fout bij goedkeuren van uitgave',
  'Expense rejected': 'Uitgave afgewezen',
  'Payroll rejected': 'Salaris afgewezen',
  'Error rejecting expense': 'Fout bij afwijzen van uitgave',
  'Delete this expense?': 'Deze uitgave verwijderen?',
  'Expense deleted': 'Uitgave verwijderd',
  'Error deleting expense': 'Fout bij verwijderen van uitgave',
  'Revenue created successfully!': 'Inkomst succesvol aangemaakt!',
  'Error creating revenue': 'Fout bij aanmaken van inkomst',
  'Delete this revenue?': 'Deze inkomst verwijderen?',
  'Error deleting revenue': 'Fout bij verwijderen van inkomst',
  'Budget created!': 'Budget aangemaakt!',
  'Error creating budget': 'Fout bij aanmaken van budget',
  'Budget updated!': 'Budget bijgewerkt!',
  'Error updating budget': 'Fout bij bijwerken van budget',
  'Delete this budget?': 'Dit budget verwijderen?',
  'Budget deleted': 'Budget verwijderd',
  'Error deleting budget': 'Fout bij verwijderen van budget',
  'Finance Management': 'Financieel beheer',
  '💵 Revenues': '💵 Inkomsten',
  'Burn Rate': 'Burn rate',
  'vs last month': 't.o.v. vorige maand',
  'Runway': 'Runway',
  'months': 'maanden',
  'Budget Alerts': 'Budgetwaarschuwingen',
  'Categories over 80%': 'Categorieën boven 80%',
  'Cash on Hand': 'Beschikbare kas',
  '{count} records': '{count} records',
  'Pending Expenses': 'Openstaande uitgaven',
  'Awaiting approval': 'Wacht op goedkeuring',
  'Net Profit': 'Nettowinst',
  'Revenue minus expenses': 'Inkomsten minus uitgaven',
  'Expense History': 'Uitgavengeschiedenis',
  'Loading expense history...': 'Uitgavengeschiedenis laden...',
  'No expenses found for the selected period': 'Geen uitgaven gevonden voor de geselecteerde periode',
  'View Receipt': 'Bon bekijken',
  'Pending Revenues': 'Openstaande inkomsten',
  'Awaiting confirmation': 'Wacht op bevestiging',
  'Current month revenue': 'Inkomsten van deze maand',
  'Revenue History': 'Inkomstengeschiedenis',
  'Loading revenue history...': 'Inkomstengeschiedenis laden...',
  'No revenues found for the selected period': 'Geen inkomsten gevonden voor de geselecteerde periode',
  'Budget vs Actual Spending': 'Budget versus werkelijke uitgaven',
  'Budget': 'Budget',
  'Actual': 'Werkelijk',
  'Budget:': 'Budget:',
  'Spent (Approved + Pending):': 'Uitgegeven (goedgekeurd + in behandeling):',
  'Remaining:': 'Resterend:',
  'Over budget by {amount}': '{amount} over budget',
  '{pct}% remaining': '{pct}% resterend',
  'All Budgets': 'Alle budgetten',
  'Loading budgets...': 'Budgetten laden...',
  'No budgets found': 'Geen budgetten gevonden',
  'Financial Trends (Last 6 Months)': 'Financiële trends (laatste 6 maanden)',
  'Expense Distribution': 'Verdeling uitgaven',
  'No trend data available': 'Geen trendgegevens beschikbaar',
  'Create Expense': 'Uitgave aanmaken',
  'Custom Category...': 'Aangepaste categorie...',
  'Enter custom category name...': 'Naam van aangepaste categorie invoeren...',
  'Subcategory': 'Subcategorie',
  'Select subcategory...': 'Selecteer subcategorie...',
  'Amount *': 'Bedrag *',
  'Add expense details...': 'Voeg uitgavedetails toe...',
  'Create Revenue': 'Inkomst aanmaken',
  'Select method...': 'Selecteer methode...',
  'Credit Card': 'Creditcard',
  'Add revenue details...': 'Voeg inkomstdetails toe...',
  'Create Budget': 'Budget aanmaken',
  'Period Type *': 'Periodetype *',
  'Quarterly': 'Per kwartaal',
  'Edit Expense': 'Uitgave bewerken',
  'Category:': 'Categorie:',
  'Subcategory:': 'Subcategorie:',
  'Current Status:': 'Huidige status:',
  'Update Expense': 'Uitgave bijwerken',
  'Edit Budget': 'Budget bewerken',
  'Update Budget': 'Budget bijwerken',
  'Expense:': 'Uitgave:',
  'Select Receipt File': 'Bonbestand selecteren',
  'Allowed: JPG, PNG, PDF (Max 5MB)': 'Toegestaan: JPG, PNG, PDF (max. 5 MB)',
  'operational': 'operationeel',
  'Stationery': 'Kantoorartikelen',
  'Paper & Printing': 'Papier & printen',
  'Office Equipment': 'Kantoorapparatuur',
  'Furniture': 'Meubilair',
  'Equipment': 'Apparatuur',
  'Computers': 'Computers',
  'Software Licenses': 'Softwarelicenties',
  'Tools': 'Gereedschap',
  'Machinery': 'Machines',
  'Travel': 'Reizen',
  'Airfare': 'Vliegtickets',
  'Hotel': 'Hotel',
  'Meals': 'Maaltijden',
  'Local Transport': 'Lokaal vervoer',
  'Car Rental': 'Autoverhuur',
  'Utilities': 'Nutsvoorzieningen',
  'Electricity': 'Elektriciteit',
  'Water': 'Water',
  'Internet': 'Internet',
  'Gas': 'Gas',
  'Salaries': 'Salarissen',
  'Marketing': 'Marketing',
  'Digital Ads': 'Digitale advertenties',
  'Print Media': 'Gedrukte media',
  'Social Media': 'Sociale media',
  'Events': 'Evenementen',
  'Sponsorships': 'Sponsoring',
  'Miscellaneous': 'Diversen',
  'Investment': 'Investering',
  'Investment Income': 'Beleggingsinkomsten',
  'Consulting': 'Advies',
  'Consulting Fees': 'Advieskosten',
  'Grants': 'Subsidies',
  'Grants & Funding': 'Subsidies & financiering',
  'Interest': 'Rente',
  'Interest Income': 'Rente-inkomsten',
  'Other Revenue': 'Overige inkomsten',
  'Product/Service Sales': 'Product-/dienstverkoop',
  'Vendor:': 'Leverancier:',
  'Tax Deductible:': 'Fiscaal aftrekbaar:',
  'Error loading tax configurations': 'Fout bij laden van belastingconfiguraties',
  'At least one bracket is required': 'Er is minstens één schijf vereist',
  'Bracket {n}: Please fill min amount and tax rate': 'Schijf {n}: Vul het minimumbedrag en het belastingtarief in',
  'Bracket {a} max amount must be less than Bracket {b} min amount': 'Maximumbedrag van schijf {a} moet lager zijn dan het minimumbedrag van schijf {b}',
  'Bracket {n}: min amount must be a number of 0 or more': 'Schijf {n}: het minimumbedrag moet een getal van 0 of meer zijn',
  'Bracket {n}: tax rate must be between 0 and 100': 'Schijf {n}: het belastingtarief moet tussen 0 en 100 liggen',
  'Bracket {n}: max amount must be a number or empty': 'Schijf {n}: het maximumbedrag moet een getal zijn of leeg blijven',
  'Bracket 1 must start at 0': 'Schijf 1 moet bij 0 beginnen',
  'Bracket {n} must start at {start}, where bracket {prev} ends': 'Schijf {n} moet beginnen bij {start}, waar schijf {prev} eindigt',
  'Bracket {n}: only the last bracket can have no max amount': 'Schijf {n}: alleen de laatste schijf mag geen maximumbedrag hebben',
  'Bracket {n}: the last bracket must have no max amount, so all income above it is taxed': 'Schijf {n}: de laatste schijf mag geen maximumbedrag hebben, zodat al het inkomen daarboven belast wordt',
  'Bracket {n}: max amount must be greater than min amount': 'Schijf {n}: het maximumbedrag moet groter zijn dan het minimumbedrag',
  'Tax configuration updated successfully!': 'Belastingconfiguratie succesvol bijgewerkt!',
  'Tax configuration created successfully!': 'Belastingconfiguratie succesvol aangemaakt!',
  'Error saving tax configuration': 'Fout bij opslaan van belastingconfiguratie',
  '✅ Deduction/Benefit updated successfully!': '✅ Inhouding/toeslag succesvol bijgewerkt!',
  '✅ Deduction/Benefit created successfully!': '✅ Inhouding/toeslag succesvol aangemaakt!',
  'Error saving deduction/benefit': 'Fout bij opslaan van inhouding/toeslag',
  'Are you sure you want to delete this tax configuration?': 'Weet je zeker dat je deze belastingconfiguratie wilt verwijderen?',
  'Tax configuration deleted successfully!': 'Belastingconfiguratie succesvol verwijderd!',
  'Error deleting tax configuration': 'Fout bij verwijderen van belastingconfiguratie',
  'Are you sure you want to delete this deduction/benefit?': 'Weet je zeker dat je deze inhouding/toeslag wilt verwijderen?',
  '✅ Deduction/Benefit deleted successfully!': '✅ Inhouding/toeslag succesvol verwijderd!',
  'Error deleting deduction/benefit': 'Fout bij verwijderen van inhouding/toeslag',
  'Deactivate Loonbelasting (LB_SRD)? No SRD payroll can be calculated while it is inactive.': 'Loonbelasting (LB_SRD) uitschakelen? Zolang deze inactief is, kan geen SRD-salaris worden berekend.',
  'Error toggling tax status': 'Fout bij wijzigen van belastingstatus',
  'Manage taxes': 'Beheer belastingen',
  'Deductions and benefits are managed on their own pages:': 'Inhoudingen en toeslagen worden op hun eigen pagina beheerd:',
  'Create {type}': '{type} aanmaken',
  'Tax': 'Belasting',
  '💵 Tax Configurations': '💵 Belastingconfiguraties',
  'USD Taxes': 'USD-belastingen',
  'Fixed': 'Vast',
  'Tiered/Progressive': 'Getrapt/progressief',
  'Structure:': 'Structuur:',
  'Progressive Brackets': 'Progressieve schijven',
  'Applies to:': 'Van toepassing op:',
  'gross': 'bruto',
  'net': 'netto',
  'base': 'basis',
  'Employer:': 'Werkgever:',
  'SRD Taxes': 'SRD-belastingen',
  'No tax configurations found': 'Geen belastingconfiguraties gevonden',
  '💎 Benefits': '💎 Toeslagen',
  '{pct}% of {applies}': '{pct}% van {applies}',
  '💰 Allowances': '💰 Toelagen',
  'No deductions/benefits found': 'Geen inhoudingen/toeslagen gevonden',
  'Edit Tax Configuration': 'Belastingconfiguratie bewerken',
  'Create Tax Configuration': 'Belastingconfiguratie aanmaken',
  'Basic Information': 'Basisgegevens',
  'e.g., Federal Income Tax': 'bijv. federale inkomstenbelasting',
  'e.g., FIT': 'bijv. FIT',
  'Percentage (Simple Rate)': 'Percentage (enkel tarief)',
  'Fixed amount deducted': 'Vast bedrag wordt ingehouden',
  'Multiple tax brackets with different rates': 'Meerdere belastingschijven met verschillende tarieven',
  'Tax Brackets (Progressive Ranges)': 'Belastingschijven (progressieve ranges)',
  'Bracket {n}': 'Schijf {n}',
  'Min Amount *': 'Minimumbedrag *',
  'e.g., Low income bracket': 'bijv. lage-inkomensschijf',
  'Remove bracket': 'Schijf verwijderen',
  'Example:': 'Voorbeeld:',
  'Bracket 1: $0 - $10,000 → 5%': 'Schijf 1: $0 - $10.000 → 5%',
  'Bracket 2: $10,001 - $25,000 → 10%': 'Schijf 2: $10.001 - $25.000 → 10%',
  'Bracket 3: $25,001 - $50,000 → 15%': 'Schijf 3: $25.001 - $50.000 → 15%',
  'Bracket 4: $50,001+ → 20%': 'Schijf 4: $50.001+ → 20%',
  'Lower numbers are calculated first': 'Lagere nummers worden eerst berekend',
  'Employer Contribution (Optional)': 'Werkgeversbijdrage (optioneel)',
  'Employer also contributes to this tax': 'De werkgever draagt ook bij aan deze belasting',
  'Employer Rate (%)': 'Werkgeverstarief (%)',
  'Mandatory Tax (cannot be opted out)': 'Verplichte belasting (kan niet worden uitgesloten)',
  'Update Tax': 'Belasting bijwerken',
  'Create Tax': 'Belasting aanmaken',
  '✏️ Edit Deduction/Benefit': '✏️ Inhouding/toeslag bewerken',
  '➕ Create Deduction/Benefit': '➕ Inhouding/toeslag aanmaken',
  'Calculation Type *': 'Berekeningstype *',
  'Percentage *': 'Percentage *',
  'Allowance': 'Toelage',
  'Applies To': 'Van toepassing op',
  'Description (Optional)': 'Beschrijving (optioneel)',
  'absence': 'afwezigheid',
  'custom': 'aangepast',

  // ── Activity action labels ──────────────────────────────
  'User Login': 'Gebruiker ingelogd',
  'User Logout': 'Gebruiker uitgelogd',
  'Password Changed': 'Wachtwoord gewijzigd',
  'Profile Updated': 'Profiel bijgewerkt',
  'Employee Created': 'Werknemer aangemaakt',
  'Employee Updated': 'Werknemer bijgewerkt',
  'Employee Deleted': 'Werknemer verwijderd',
  'Account Locked': 'Account vergrendeld',
  'Session Revoked': 'Sessie ingetrokken',
  'Menu': 'Menu',
  'Session expired. Please sign in again.': 'Sessie verlopen. Log opnieuw in.',
  'Dark mode': 'Donkere modus',
  'Light mode': 'Lichte modus',
  'My Portal': 'Mijn portaal',
  'Welcome back, {name}!': 'Welkom terug, {name}!',
  'Overview': 'Overzicht',
  'Payslips': 'Loonstroken',
  'Leave': 'Verlof',
  'No employee profile is linked to this account': 'Er is geen werknemersprofiel gekoppeld aan dit account',
  'Ask HR to link your user to an employee record (same email or user_id).': 'Vraag HR om je gebruiker te koppelen aan een werknemer (hetzelfde e-mailadres of user_id).',
  'Recent payslips': 'Recente loonstroken',
  'No payroll records found': 'Geen salarisrecords gevonden',
  'No contracts found': 'Geen contracten gevonden',
  'No documents found': 'Geen documenten gevonden',
  'Error loading data': 'Fout bij laden van gegevens',
  'Error loading finance data': 'Fout bij laden van financiële gegevens',
  'Error loading employees': 'Fout bij laden van werknemers',
  'Error loading contracts': 'Fout bij laden van contracten',
  'Error loading payroll summary': 'Fout bij laden van het salarisoverzicht',
  'Error loading users': 'Fout bij laden van gebruikers',
  'Error loading activity logs': 'Fout bij laden van activiteitenlogboeken',
  'Error loading system statistics': 'Fout bij laden van systeemstatistieken',
  'Error loading approval requests': 'Fout bij laden van goedkeuringsaanvragen',
  'Error loading documents': 'Fout bij laden van documenten',
  'Error loading consolidation statistics': 'Fout bij laden van consolidatiestatistieken',
  'Error loading dashboard': 'Fout bij laden van het dashboard',
  'Error loading contract templates': 'Fout bij laden van contractsjablonen',
  'Error loading benefit types': 'Fout bij laden van soorten voordelen',
  'Error loading employee benefits': 'Fout bij laden van werknemersvoordelen',
  'Error loading leave types': 'Fout bij laden van verloftypen',
  'Error loading attendance': 'Fout bij laden van aanwezigheid',
  'Error loading leave requests': 'Fout bij laden van verlofaanvragen',
  'Error loading leave balance': 'Fout bij laden van verlofsaldo',
  'Error loading report': 'Fout bij laden van het rapport',
  'Error loading attendance report': 'Fout bij laden van het aanwezigheidsrapport',
  'Edit Revenue': 'Inkomsten bewerken',
  'Update Revenue': 'Inkomsten bijwerken',
  'Revenue updated!': 'Inkomsten bijgewerkt!',
  'Error updating revenue': 'Fout bij bijwerken van inkomsten',
  'Opening balance: {amount}': 'Beginsaldo: {amount}',
  'Opening balance ({currency})': 'Beginsaldo ({currency})',
  'Cash on hand = opening balance + approved revenues − approved expenses, for all dates.': 'Kassaldo = beginsaldo + goedgekeurde inkomsten − goedgekeurde uitgaven, over alle datums.',
  'Approved revenues:': 'Goedgekeurde inkomsten:',
  'Approved expenses:': 'Goedgekeurde uitgaven:',
  'Opening balance *': 'Beginsaldo *',
  'Opening balance updated!': 'Beginsaldo bijgewerkt!',
  'Error updating opening balance': 'Fout bij bijwerken van beginsaldo',
  'Your password was reset. Choose a new one to continue.': 'Je wachtwoord is gereset. Kies een nieuw wachtwoord om verder te gaan.',
  'Profit this month': 'Winst deze maand',
  'Revenue this month': 'Inkomsten deze maand',
  'Expenses this month': 'Uitgaven deze maand',
  'Last 12 months': 'Laatste 12 maanden',
  'Profit': 'Winst',
  'Previous month': 'Vorige maand',
  'Next month': 'Volgende maand',
  'Revenue vs expenses (6 months)': 'Inkomsten vs uitgaven (6 maanden)',
  'Approved records only': 'Alleen goedgekeurde boekingen',
  'Custom range': 'Aangepaste periode',
  'By month': 'Per maand',
  '✅ {created} attendance records created, {skipped} skipped (the day already had a record)': '✅ {created} aanwezigheidsrecords aangemaakt, {skipped} overgeslagen (de dag had al een record)',
  'Days that already have a record are skipped, not overwritten': 'Dagen die al een record hebben worden overgeslagen, niet overschreven',
  'Not all payrolls for this month could be loaded: the totals below are incomplete.': 'Niet alle salarisberekeningen van deze maand konden worden geladen: de totalen hieronder zijn onvolledig.',
  '✅ Leave request submitted': '✅ Verlofaanvraag ingediend',
  'Error submitting leave request': 'Fout bij indienen van verlofaanvraag',
  'Error downloading document': 'Fout bij downloaden van document',
  'Download PDF': 'PDF downloaden',
  'employee': 'werknemer',

  // ── Time & Attendance ───────────────────────────────────
  'Not in yet': 'Nog niet binnen',
  'Working': 'Aan het werk',
  'Clocked out': 'Uitgeklokt',
  'Absent / sick / leave': 'Afwezig / ziek / verlof',
  'Could not load today\'s attendance': 'Kon de aanwezigheid van vandaag niet laden',
  '{name} clocked in at {time}': '{name} ingeklokt om {time}',
  'now': 'nu',
  '{name} clocked out at {time}': '{name} uitgeklokt om {time}',
  'Time (empty = now)': 'Tijd (leeg = nu)',
  'Clock in': 'Inklokken',
  'Clock out': 'Uitklokken',
  'Working (late {minutes} min)': 'Aan het werk (te laat {minutes} min)',
  'Night shift since yesterday {time}': 'Nachtdienst sinds gisteren {time}',
  'Retry': 'Opnieuw proberen',
  'Suriname time': 'Surinaamse tijd',
  'Updated at {time}': 'Bijgewerkt om {time}',
  'Open night shifts': 'Open nachtdiensten',
  'since yesterday {time}': 'sinds gisteren {time}',
  'Search employee or position...': 'Zoek werknemer of functie...',
  'In': 'In',
  'Out': 'Uit',
  'No employees match': 'Geen werknemers gevonden',

  // ── Time & Attendance: Week ───────────────────────────
  'Night shift (ends next day)': 'Nachtdienst (eindigt de volgende dag)',
  'Paid leave': 'Betaald verlof',
  'Unpaid leave': 'Onbetaald verlof',
  'Nothing to export': 'Niets om te exporteren',
  'Pay': 'Loon',
  'Hours worked': 'Gewerkte uren',
  'Previous week': 'Vorige week',
  'Week {number} · Monday to Sunday · Suriname time': 'Week {number} · maandag tot zondag · Surinaamse tijd',
  'Next week': 'Volgende week',
  'This week': 'Deze week',
  'Employee or position': 'Werknemer of functie',
  'All departments': 'Alle afdelingen',
  'Pay type': 'Soort loon',
  'Hourly and monthly': 'Per uur en per maand',
  'Export Excel': 'Exporteren naar Excel',
  'Attendance of the week {range}': 'Aanwezigheid van de week {range}',
  'today': 'vandaag',
  'Week total': 'Weektotaal',
  'No record': 'Geen registratie',
  'Worked / with a record': 'Gewerkt / met registratie',
  'Overtime {minutes} min': 'Overuren {minutes} min',
  'Overtime {hours} h': 'Overuren {hours} u',
  'Late {minutes} min': 'Te laat {minutes} min',
  'night': 'nacht',
  'open': 'open',
  'sick pay': 'ziekteloon',
  'holiday {hours}': 'feestdag {hours}',
  'Sunday {hours}': 'zondag {hours}',
  'paid leave {hours}': 'betaald verlof {hours}',
  'overtime {minutes} min': 'overuren {minutes} min',
  '{count} absent': '{count} afwezig',
  '{count} sick': '{count} ziek',
  '{count} unpaid': '{count} onbetaald',
  '{currency} {amount} / h': '{currency} {amount} / u',
  'No hourly rate': 'Geen uurloon',
  '{currency} {amount} / month': '{currency} {amount} / maand',
  'No salary': 'Geen salaris',

  // ── Time & Attendance: Mark as ────────────────────────
  'All the selected days already have a record. Tick "Overwrite" to change them.': 'Alle geselecteerde dagen hebben al een registratie. Vink "Overschrijven" aan om ze te wijzigen.',
  'Selection': 'Selectie',
  '{count} days selected': '{count} dagen geselecteerd',
  '{count} already have a record': '{count} hebben al een registratie',
  'Mark as': 'Markeren als',
  'Leave type': 'Soort verlof',
  'unpaid': 'onbetaald',
  'Overwrite the days that already have a record': 'De dagen met een registratie overschrijven',
  'You can view this week but not change it': 'U kunt deze week bekijken maar niet wijzigen',
  'Overwrite days?': 'Dagen overschrijven?',
  'Change {count} days': '{count} dagen wijzigen',
  '{count} days that already have a record will be changed to "{status}". Their times stay; status and hours change.': '{count} dagen met een registratie worden gewijzigd in "{status}". De tijden blijven; status en uren veranderen.',
  '{count} empty days will be filled.': '{count} lege dagen worden ingevuld.',

  // ── Time & Attendance: Copy week ──────────────────────
  'Copy previous week': 'Vorige week kopiëren',
  'Copy previous week…': 'Vorige week kopiëren…',
  'Create {count} days': '{count} dagen aanmaken',
  'From {from} into {to}.': 'Van {from} naar {to}.',
  'What to copy': 'Wat kopiëren',
  'Shifts (present days, with their clock-in and clock-out times)': 'Diensten (aanwezige dagen, met hun in- en uitkloktijden)',
  'Absences, sick days and leave': 'Afwezigheid, ziektedagen en verlof',
  'Employees: the {count} shown in the grid.': 'Werknemers: de {count} die in het rooster staan.',
  'days will be created': 'dagen worden aangemaakt',
  'skipped: they already have a record or the employee is no longer active': 'overgeslagen: ze hebben al een registratie of de werknemer is niet meer actief',
  'on a public holiday: {names}': 'op een feestdag: {names}',
  'on a public holiday (none this week)': 'op een feestdag (geen deze week)',
  'Nothing is overwritten. Days copied onto a public holiday count as worked holiday hours; change them in the grid if the post is closed. Lateness and overtime are not copied.': 'Er wordt niets overschreven. Dagen die op een feestdag vallen tellen als gewerkte feestdaguren; wijzig ze in het rooster als de post dicht is. Te laat komen en overuren worden niet gekopieerd.',

  // ── Time & Attendance: Copy week warning ──────────────
  'This creates real worked days. If someone does not come, change their day to absent or payroll will pay it.': 'Dit maakt echte gewerkte dagen aan. Als iemand niet komt, zet zijn dag op afwezig, anders betaalt de loonadministratie hem.',

  // ── Time & Attendance: singular and plural ────────────
  '{count} changed': '{count} gewijzigd',
  '{count} skipped (they already had a record)': '{count} overgeslagen (ze hadden al een registratie)',
  '{count} day filled': '{count} dag ingevuld',
  '{count} days filled': '{count} dagen ingevuld',
  '{count} day selected': '{count} dag geselecteerd',
  '{count} already has a record': '{count} heeft al een registratie',
  'Change {count} day': '{count} dag wijzigen',
  '{count} day that already has a record will be changed to "{status}". Its times stay; status and hours change.': '{count} dag met een registratie wordt gewijzigd in "{status}". De tijden blijven; status en uren veranderen.',
  '{count} empty day will be filled.': '{count} lege dag wordt ingevuld.',
  '{count} day created': '{count} dag aangemaakt',
  '{count} days created': '{count} dagen aangemaakt',
  'Create {count} day': '{count} dag aanmaken',
  'Employees: the one shown in the grid.': 'Werknemers: degene die in het rooster staat.',
  'day will be created': 'dag wordt aangemaakt',

  // ── Time & Attendance: side panel ─────────────────────
  'employee setting': 'instelling van de werknemer',
  'default': 'standaard',
  'Day saved': 'Dag opgeslagen',
  'Day deleted': 'Dag verwijderd',
  '1.0× · premium disabled in Settings': '1,0× · toeslag uitgeschakeld in Instellingen',
  'Delete this day? This cannot be undone.': 'Deze dag verwijderen? Dit kan niet ongedaan worden gemaakt.',
  'Delete day': 'Dag verwijderen',
  'Break (min)': 'Pauze (min)',
  'Hours counted': 'Getelde uren',
  'From the clock times minus the break; a clock-out earlier than the clock-in ends the next morning.': 'Uit de kloktijden min de pauze; een uitkloktijd vóór de inkloktijd eindigt de volgende ochtend.',
  'Monthly employees: a standard day ({hours} h) whatever the status, as payroll counts them today.': 'Maandloners: een standaarddag ({hours} u) ongeacht de status, zoals de loonadministratie ze nu telt.',
  'Hourly employees are paid hours only for days present and paid leave.': 'Uurloners krijgen alleen uren betaald voor aanwezige dagen en betaald verlof.',
  'Day type, from the calendar': 'Soort dag, volgens de kalender',
  'Public holiday: {name}': 'Feestdag: {name}',
  'Regular day': 'Gewone dag',
  'Company holiday (not in the calendar)': 'Bedrijfsvrije dag (niet in de kalender)',
  'Overtime (minutes)': 'Overuren (minuten)',
  'Overtime (hours)': 'Overuren (uren)',
  'Deduction (% of the day)': 'Inhouding (% van de dag)',
  'Rates payroll applies': 'Tarieven die de loonadministratie toepast',
  'Hourly rate': 'Uurloon',
  'from the monthly salary': 'uit het maandsalaris',
  'Public holiday': 'Feestdag',
  'Shown when the day has something to pay.': 'Zichtbaar zodra de dag iets te betalen heeft.',
  'Rates are not edited per day: they come from the employee or Settings.': 'Tarieven worden niet per dag gewijzigd: ze komen van de werknemer of uit Instellingen.',
  'Pay preview for this day': 'Voorbeeldberekening van deze dag',
  'Nothing to pay for this day.': 'Niets te betalen voor deze dag.',
  'Total, before taxes': 'Totaal, vóór belastingen',
  'Calculated by payroll itself, as if this day were saved.': 'Berekend door de loonadministratie zelf, alsof deze dag is opgeslagen.',
  'Unpaid leave.': 'Onbetaald verlof.',

  // ── Time & Attendance: what payroll applies ───────────
  'Absence': 'Afwezigheid',
  'The whole day is deducted (daily rate)': 'De hele dag wordt ingehouden (dagloon)',
  'Not paid (0 h), no deduction on top': 'Niet betaald (0 u), geen extra inhouding',
  'Sick pay': 'Ziekteloon',
  '{percent} % · Settings': '{percent} % · Instellingen',
  'The percentage set in Settings': 'Het percentage uit Instellingen',

  // ── Time & Attendance: Employee ───────────────────────
  'Choose an employee…': 'Kies een werknemer…',
  'Choose an employee to see their month.': 'Kies een werknemer om zijn maand te zien.',
  '{name}, {month}': '{name}, {month}',
  'Totals of the month': 'Totalen van de maand',
  'As payroll counts them (the same calculation).': 'Zoals de loonadministratie ze telt (dezelfde berekening).',
  'Days worked': 'Gewerkte dagen',
  'normal': 'gewoon',
  '{minutes} min': '{minutes} min',
  'Absent days': 'Afwezige dagen',
  'Sick days': 'Ziektedagen',
  'Leave days': 'Verlofdagen',
  '{paid} paid · {unpaid} unpaid': '{paid} betaald · {unpaid} onbetaald',
  'Monthly employees: overtime is paid in minutes; their pay still counts the hours of every day.': 'Maandloners: overuren worden in minuten betaald; hun loon telt nog steeds de uren van elke dag.',
  'Hourly employees: hours count only for days present and paid leave.': 'Uurloners: uren tellen alleen voor aanwezige dagen en betaald verlof.',

  // ── Time & Attendance: Leave ──────────────────────────
  'Leave approved': 'Verlof goedgekeurd',
  'Overlaps approved leave: {type}, {range}': 'Overlapt met goedgekeurd verlof: {type}, {range}',
  'All employees': 'Alle werknemers',
  'All types': 'Alle soorten',
  'Used in {year}: {list}': 'Gebruikt in {year}: {list}',
  'No leave used in {year}': 'Geen verlof gebruikt in {year}',
  'by {who}': 'door {who}',
  'No leave requests match': 'Geen verlofaanvragen gevonden',
  'Approve leave': 'Verlof goedkeuren',
  'Reject leave': 'Verlof afwijzen',
  'Approving creates the leave days (Monday to Friday) in the attendance.': 'Goedkeuren maakt de verlofdagen (maandag tot vrijdag) aan in de aanwezigheid.',
  'Note (optional)': 'Opmerking (optioneel)',
  'Reason (required)': 'Reden (verplicht)',
  '{count} day of this range already has another record (approving turns it into leave)': '{count} dag in deze periode heeft al een andere registratie (goedkeuren maakt er verlof van)',
  '{count} days of this range already have another record (approving turns them into leave)': '{count} dagen in deze periode hebben al een andere registratie (goedkeuren maakt er verlof van)',
  '{count} request waiting for a decision': '{count} aanvraag wacht op een beslissing',
  '{count} requests waiting for a decision': '{count} aanvragen wachten op een beslissing',
  '{count} day': '{count} dag',
  '{count} weekday': '{count} werkdag',
  '{count} weekdays': '{count} werkdagen',

  // ── Menu ──────────────────────────────────────────────
  '{count} leave request waiting for a decision': '{count} verlofaanvraag wacht op een beslissing',
  '{count} leave requests waiting for a decision': '{count} verlofaanvragen wachten op een beslissing',

  // ── Tax Config: tax form ──────────────────────────────
  'Informational: payroll does not apply this row. It applies the AOV % of the Loonbelasting year (tax year section above).': 'Ter informatie: de loonberekening past deze regel niet toe. Ze past het AOV-% van het Loonbelasting-jaar toe (belastingjaar hierboven).',
  'Payroll applies the brackets of the year and the Loonbelasting parameters above; a minimum or maximum does not apply.': 'De loonberekening past de schijven van het jaar en de Loonbelasting-parameters hierboven toe; een minimum of maximum geldt niet.',
  'Minimum base:': 'Minimale grondslag:',
  'Maximum tax:': 'Maximale belasting:',
  'Informational': 'Ter informatie',
  'Amount ({currency}) *': 'Bedrag ({currency}) *',
  'Deducted from each payroll': 'Wordt bij elke loonberekening ingehouden',
  'Minimum base ({currency})': 'Minimale grondslag ({currency})',
  'No tax while the base is below this amount. Empty: no minimum.': 'Geen belasting zolang de grondslag onder dit bedrag ligt. Leeg: geen minimum.',
  'Maximum tax ({currency})': 'Maximale belasting ({currency})',
  'The most this tax takes from one payroll. Empty: no maximum.': 'Het meeste dat deze belasting per loonberekening inhoudt. Leeg: geen maximum.',

  // ── Tax Config: simulation ────────────────────────────
  'Fill in every amount before simulating': 'Vul elk bedrag in voordat u simuleert',
  'Error simulating the tax year': 'Fout bij het simuleren van het belastingjaar',
  'Simulation on the last approved payroll': 'Simulatie op de laatste goedgekeurde loonberekening',
  'Recalculates the last approved payroll of {year} with the parameters above, saved or not, and compares it with what was approved. Nothing is saved.': 'Berekent de laatste goedgekeurde loonberekening van {year} opnieuw met de parameters hierboven, opgeslagen of niet, en vergelijkt die met wat is goedgekeurd. Er wordt niets opgeslagen.',
  'Simulate': 'Simuleren',
  'There is no approved payroll for {year} yet, so there is nothing to compare with. The simulation will be available once a payroll of {year} is approved.': 'Er is nog geen goedgekeurde loonberekening voor {year}, dus er is niets om mee te vergelijken. De simulatie is beschikbaar zodra een loonberekening van {year} is goedgekeurd.',
  'Payroll of {start} to {end}: {count} guards': 'Loonberekening van {start} tot {end}: {count} bewakers',
  'Marked ⚠️: the gross recalculated today is not the approved one (attendance or rates changed since), so the difference is not only the parameters.': 'Gemarkeerd ⚠️: het vandaag herberekende bruto is niet het goedgekeurde (aanwezigheid of tarieven zijn sindsdien gewijzigd), dus het verschil komt niet alleen door de parameters.',
  'LB approved': 'LB goedgekeurd',
  'LB new': 'LB nieuw',
  'AOV approved': 'AOV goedgekeurd',
  'AOV new': 'AOV nieuw',
  'Net approved': 'Netto goedgekeurd',
  'Net new': 'Netto nieuw',
  'Difference': 'Verschil',
  'The gross recalculated today is not the approved one': 'Het vandaag herberekende bruto is niet het goedgekeurde',
  '{count} payrolls could not be recalculated and are not in the totals.': '{count} loonberekeningen konden niet opnieuw worden berekend en staan niet in de totalen.',
  'Error loading clients': 'Fout bij laden van klanten',
  'Error loading sites': 'Fout bij laden van posten',
  'Client updated': 'Klant bijgewerkt',
  'Client created': 'Klant aangemaakt',
  'Error saving the client': 'Fout bij opslaan van de klant',
  'Client activated': 'Klant geactiveerd',
  'Client deactivated': 'Klant gedeactiveerd',
  'Site updated': 'Post bijgewerkt',
  'Site created': 'Post aangemaakt',
  'Error saving the site': 'Fout bij opslaan van de post',
  'Site activated': 'Post geactiveerd',
  'Site deactivated': 'Post gedeactiveerd',
  'Clients & Sites': 'Klanten en posten',
  'The clients and the posts where guards are planned': 'De klanten en de posten waar bewakers worden ingepland',
  'New Client': 'Nieuwe klant',
  'Loading clients...': 'Klanten laden...',
  'No clients yet': 'Nog geen klanten',
  '{active} of {total} sites active': '{active} van {total} posten actief',
  'Edit client': 'Klant bewerken',
  'Deactivate client': 'Klant deactiveren',
  'Activate client': 'Klant activeren',
  'Sites': 'Posten',
  'New Site': 'Nieuwe post',
  'This client has no sites yet': 'Deze klant heeft nog geen posten',
  'Site': 'Post',
  'Location': 'Locatie',
  'Geofence (m)': 'Geofence (m)',
  'Guards needed': 'Benodigde bewakers',
  'Not placed yet': 'Nog niet geplaatst',
  'Edit site': 'Post bewerken',
  'Deactivate site': 'Post deactiveren',
  'Activate site': 'Post activeren',
  'Edit Client': 'Klant bewerken',
  'Edit Site': 'Post bewerken',
  'Both or neither: a site without a point has no geofence yet.': 'Beide of geen van beide: een post zonder punt heeft nog geen geofence.',
  'Check on the map': 'Bekijken op de kaart',
  'Contact person': 'Contactpersoon',
  'Latitude': 'Breedtegraad',
  'Longitude': 'Lengtegraad',
  'Geofence radius (m)': 'Straal geofence (m)',
  'Shifts': 'Diensten',
  'Who is planned where, week by week': 'Wie waar is ingepland, week per week',
  'By site': 'Per post',
  'By guard': 'Per bewaker',
  'All sites': 'Alle posten',
  'Print': 'Afdrukken',
  'Loading shifts...': 'Diensten laden...',
  'No sites yet: add them under Clients & Sites': 'Nog geen posten: voeg ze toe onder Klanten en posten',
  '{n} guards needed': '{n} bewakers nodig',
  '{planned} of {needed} guards': '{planned} van {needed} bewakers',
  'No guards planned this week': 'Deze week geen bewakers ingepland',
  'Plan a Shift': 'Dienst inplannen',
  'Plan a shift on {day}': 'Dienst inplannen op {day}',
  'Copy the shifts at {site} of the week of {from} into this week?': 'De diensten op {site} van de week van {from} naar deze week kopiëren?',
  'Copy all shifts of the week of {from} into this week?': 'Alle diensten van de week van {from} naar deze week kopiëren?',
  'Error copying the week': 'Fout bij kopiëren van de week',
  'Week copied': 'Week gekopieerd',
  '{n} shifts created': '{n} diensten aangemaakt',
  '{n} not copied:': '{n} niet gekopieerd:',
  'No shifts to export': 'Geen diensten om te exporteren',
  'Start': 'Begin',
  'End': 'Einde',
  'Time': 'Tijd',
  'Guard': 'Bewaker',
  'Client': 'Klant',
  'Overlaps another shift of this guard: {site}, {from} – {to}': 'Overlapt met een andere dienst van deze bewaker: {site}, {from} – {to}',
  'Overlaps another shift of this guard': 'Overlapt met een andere dienst van deze bewaker',
  'This guard is not active': 'Deze bewaker is niet actief',
  'This site is not active': 'Deze post is niet actief',
  'The client of this site is not active': 'De klant van deze post is niet actief',
  'Only {hours} h of rest after the previous shift (minimum {minimum} h)': 'Slechts {hours} u rust na de vorige dienst (minimaal {minimum} u)',
  'Only {hours} h of rest before the next shift (minimum {minimum} h)': 'Slechts {hours} u rust voor de volgende dienst (minimaal {minimum} u)',
  '{hours} h planned in the week of {week} (more than {maximum} h)': '{hours} u ingepland in de week van {week} (meer dan {maximum} u)',
  'Approved leave from {from} to {to}': 'Goedgekeurd verlof van {from} tot {to}',
  'This guard is on leave': 'Deze bewaker is met verlof',
  'Shift updated': 'Dienst bijgewerkt',
  'Shift planned': 'Dienst ingepland',
  'Error saving the shift': 'Fout bij opslaan van de dienst',
  'Cancel this shift? It stays in the history as cancelled.': 'Deze dienst annuleren? Hij blijft als geannuleerd in de geschiedenis.',
  'Shift cancelled': 'Dienst geannuleerd',
  'Error cancelling the shift': 'Fout bij annuleren van de dienst',
  'Edit Shift': 'Dienst bewerken',
  'Cancel shift': 'Dienst annuleren',
  'Choose a guard': 'Kies een bewaker',
  'Choose a site': 'Kies een post',
  'Template (optional)': 'Sjabloon (optioneel)',
  'No template': 'Geen sjabloon',
  'Template created': 'Sjabloon aangemaakt',
  'Error saving the template': 'Fout bij opslaan van het sjabloon',
  'Template activated': 'Sjabloon geactiveerd',
  'Template deactivated': 'Sjabloon gedeactiveerd',
  'Shift Templates': 'Dienstsjablonen',
  'They fill in the times of a new shift': 'Ze vullen de tijden van een nieuwe dienst in',
  'No templates yet': 'Nog geen sjablonen',
  'Every site': 'Alle posten',
  'Deactivate template': 'Sjabloon deactiveren',
  'Activate template': 'Sjabloon activeren',
  'Ends the next day': 'Eindigt de volgende dag',
  'Error loading sites and guards': 'Fout bij laden van posten en bewakers',
  'Error loading templates': 'Fout bij laden van sjablonen',
  'Error loading shifts': 'Fout bij laden van diensten',
  'Map: click to place the site': 'Kaart: klik om de post te plaatsen',
  'Click the map or drag the pin to place the site; the circle is the geofence.': 'Klik op de kaart of sleep de speld om de post te plaatsen; de cirkel is de geofence.',
  'The map could not be loaded; type the coordinates instead.': 'De kaart kon niet worden geladen; typ de coördinaten in.',
  'Loading map...': 'Kaart laden...',
  'Planned': 'Ingepland',
  'yesterday {times}': 'gisteren {times}',
  'Planned from {time}, not in': 'Ingepland vanaf {time}, niet binnen',
  'Planned hours': 'Ingeplande uren',
  'planned {shifts}': 'ingepland {shifts}',
  'planned {hours}': 'ingepland {hours}',
  'Planned, no record': 'Ingepland, geen registratie',
  'Planned, not worked': 'Ingepland, niet gewerkt',
  'Could not load the planned shifts': 'Kon de ingeplande diensten niet laden',
  'Error giving portal access': 'Fout bij het geven van portaaltoegang',
  'Revoke portal access? The guard is signed out and cannot sign in again until access is given again.': 'Portaaltoegang intrekken? De bewaker wordt afgemeld en kan pas weer inloggen als de toegang opnieuw wordt gegeven.',
  'Portal access revoked': 'Portaaltoegang ingetrokken',
  'Error revoking portal access': 'Fout bij het intrekken van portaaltoegang',
  'Error loading portal access': 'Fout bij het laden van portaaltoegang',
  'Username': 'Gebruikersnaam',
  'Temporary password': 'Tijdelijk wachtwoord',
  'Copied': 'Gekopieerd',
  'Could not copy: select the text instead': 'Kopiëren lukte niet: selecteer de tekst',
  'Guard Portal': 'Bewakersportaal',
  'Revoke access': 'Toegang intrekken',
  'Give portal access': 'Portaaltoegang geven',
  'Must change the password at the next sign-in': 'Moet het wachtwoord wijzigen bij de volgende aanmelding',
  'Last sign-in': 'Laatste aanmelding',
  'Never': 'Nooit',
  'No portal access yet': 'Nog geen portaaltoegang',
  'Give these to the guard now: the password is not shown again.': 'Geef dit nu aan de bewaker: het wachtwoord wordt niet opnieuw getoond.',
  'The guard signs in at the same address as everyone else and must choose a new password.': 'De bewaker logt in op hetzelfde adres als iedereen en moet een nieuw wachtwoord kiezen.',
  'Copy': 'Kopiëren',
  'Done': 'Klaar',
  'Give this employee an employee code first: it is the username.': 'Geef deze werknemer eerst een werknemerscode: dat is de gebruikersnaam.',
  'Only active employees or employees on leave get portal access.': 'Alleen actieve werknemers of werknemers met verlof krijgen portaaltoegang.',
  'Email or username': 'E-mail of gebruikersnaam',
  'your.email@hardwallsecurity.com or your employee code': 'uw.email@hardwallsecurity.com of uw werknemerscode',
  'This account has no access to the guard portal. Ask HR.': 'Dit account heeft geen toegang tot het bewakersportaal. Vraag het aan Personeelszaken.',
  'Change your temporary password first': 'Wijzig eerst uw tijdelijke wachtwoord',
  'Guard portal': 'Bewakersportaal',
  'without a location': 'zonder locatie',
  'outside the site area': 'buiten het gebied van de post',
  'location not precise': 'locatie niet nauwkeurig',
  'Error sending the report': 'Fout bij het versturen van de melding',
  'Tomorrow': 'Morgen',
  'My shifts': 'Mijn diensten',
  'During a shift, tap "I\'m here" every {n} minutes, with this page open.': 'Tik tijdens een dienst elke {n} minuten op "Ik ben hier", met deze pagina open.',
  'No shifts planned for the coming weeks': 'Geen diensten gepland voor de komende weken',
  'Last report at {time}': 'Laatste melding om {time}',
  'Check in': 'Inklokken',
  'Check out': 'Uitklokken',
  'Sending...': 'Versturen...',
  'Error saving your answer': 'Fout bij het opslaan van uw antwoord',
  'Your location': 'Uw locatie',
  'Read this once before your first check-in': 'Lees dit eenmalig voor uw eerste keer inklokken',
  'Not now: without location': 'Niet nu: zonder locatie',
  'I agree': 'Ik ga akkoord',
  'Version {version}. You can withdraw it under Me.': 'Versie {version}. U kunt deze intrekken onder Ik.',
  'My attendance': 'Mijn aanwezigheid',
  '{days} days worked · {hours} h': '{days} dagen gewerkt · {hours} u',
  'Nothing recorded this month': 'Deze maand niets geregistreerd',
  'Error making the PDF': 'Fout bij het maken van de pdf',
  'My payslips': 'Mijn loonstroken',
  'No payslips yet': 'Nog geen loonstroken',
  'PDF': 'PDF',
  'Leave requested: {days} working days. HR will let you know.': 'Verlof aangevraagd: {days} werkdagen. Personeelszaken laat het u weten.',
  'Check the dates and the type': 'Controleer de data en het soort',
  'My leave': 'Mijn verlof',
  'Request leave': 'Verlof aanvragen',
  'Send request': 'Aanvraag versturen',
  'Days used in {year}': 'Gebruikte dagen in {year}',
  'No leave requests yet': 'Nog geen verlofaanvragen',
  '{days} days': '{days} dagen',
  'The new passwords do not match': 'De nieuwe wachtwoorden komen niet overeen',
  'Password changed': 'Wachtwoord gewijzigd',
  'Error changing the password': 'Fout bij het wijzigen van het wachtwoord',
  'Withdraw your location consent? You can still check in, without a location.': 'Uw toestemming voor de locatie intrekken? U kunt nog steeds inklokken, zonder locatie.',
  'Location consent withdrawn': 'Toestemming voor de locatie ingetrokken',
  'Me': 'Ik',
  'Something wrong? Ask HR to correct it.': 'Klopt er iets niet? Vraag Personeelszaken het te corrigeren.',
  'Location consent': 'Toestemming voor de locatie',
  'Accepted on {date} (version {version}).': 'Gegeven op {date} (versie {version}).',
  'Withdraw consent': 'Toestemming intrekken',
  'Not given. You will be asked at your next check-in.': 'Niet gegeven. Het wordt gevraagd bij uw volgende keer inklokken.',
  'Sign out': 'Afmelden',
  'Checked in': 'Ingeklokt',
  'I\'m here': 'Ik ben hier',
  'Checked out': 'Uitgeklokt',
  'Accept the location consent first, or report without a location': 'Geef eerst toestemming voor de locatie, of meld zonder locatie',
  'This shift is not open for this report now': 'Deze dienst staat nu niet open voor deze melding',
  'You have already checked in': 'U bent al ingeklokt',
  'You have already checked out': 'U bent al uitgeklokt',
  'Check in first': 'Klok eerst in',
  '"I\'m here" is not asked for now': '"Ik ben hier" wordt nu niet gevraagd',
  'This shift was cancelled': 'Deze dienst is geannuleerd',
  'Employee code': 'Werknemerscode',
  'Since': 'Sinds',
  'Current password': 'Huidig wachtwoord',
  'New password': 'Nieuw wachtwoord',
  'Repeat the new password': 'Herhaal het nieuwe wachtwoord',
  'Error loading your shifts': 'Fout bij het laden van uw diensten',
  'Error loading your attendance': 'Fout bij het laden van uw aanwezigheid',
  'Error loading your payslips': 'Fout bij het laden van uw loonstroken',
  'Error loading your leave': 'Fout bij het laden van uw verlof',
  'Error loading your details': 'Fout bij het laden van uw gegevens',
  'Error loading the location consent': 'Fout bij het laden van de toestemming voor de locatie',
  'required': 'verplicht',
  'YYYY-MM-DD': 'JJJJ-MM-DD',
  'at most 30 days ago': 'hoogstens 30 dagen geleden',
  'at most a year ahead': 'hoogstens een jaar vooruit',
  'on or after the start': 'op of na het begin',
  'at most 90 days': 'hoogstens 90 dagen',
  'no working day (Monday to Friday) in the range': 'geen werkdag (maandag tot vrijdag) in deze periode',
  'not an active leave type': 'geen actief verlofsoort',
  'at most 500 characters': 'hoogstens 500 tekens',
  'You already have a pending or approved request on these days': 'U heeft al een openstaande of goedgekeurde aanvraag op deze dagen',
  'Password must be at least 8 characters': 'Het wachtwoord moet minstens 8 tekens hebben',
  'Current password is incorrect': 'Het huidige wachtwoord is onjuist',
  'No location': 'Geen locatie',
  'Optional: the point can be added later. Without it the site has no geofence yet.': 'Optioneel: de locatie kan later worden toegevoegd. Zonder locatie heeft de post nog geen geofence.',
  'Short links (maps.app.goo.gl) cannot be read here: open the link, then copy the long address from the browser, or the coordinates.': 'Korte links (maps.app.goo.gl) kunnen hier niet worden gelezen: open de link en kopieer het lange adres uit de browser, of de coördinaten.',
  'No point found: paste a Google Maps link or coordinates such as 5.852036, -55.203828.': 'Geen locatie gevonden: plak een Google Maps-link of coördinaten zoals 5.852036, -55.203828.',
  'Point set: {lat}, {lng}': 'Locatie ingesteld: {lat}, {lng}',
  'Point set: {lat}, {lng}. It is outside Suriname: check it, or swap latitude and longitude.': 'Locatie ingesteld: {lat}, {lng}. Die ligt buiten Suriname: controleer het, of verwissel breedte- en lengtegraad.',
  'Google Maps link or coordinates': 'Google Maps-link of coördinaten',
  'Paste a link, or 5.852036, -55.203828': 'Plak een link, of 5.852036, -55.203828',
  'Point set: {place}': 'Locatie ingesteld: {place}',
  'Find the place': 'Plaats zoeken',
  'Street and district, e.g. Kwattaweg 120 Paramaribo': 'Straat en district, bijv. Kwattaweg 120 Paramaribo',
  'Searching...': 'Zoeken...',
  'The address search is not available right now: place the point on the map, paste a link or use your location.': 'Het zoeken op adres werkt nu niet: zet de locatie op de kaart, plak een link of gebruik uw locatie.',
  'Nothing found in Suriname. Try the street and the district, or place the point on the map.': 'Niets gevonden in Suriname. Probeer de straat en het district, of zet de locatie op de kaart.',
  'Point set where you are, within {metres} m: not precise. Move the pin to the gate on the map.': 'Locatie ingesteld waar u bent, binnen {metres} m: niet nauwkeurig. Zet de speld op de kaart bij de poort.',
  'Point set where you are, within {metres} m.': 'Locatie ingesteld waar u bent, binnen {metres} m.',
  'Finding you...': 'Locatie zoeken...',
  'Use my location': 'Mijn locatie gebruiken',
  'The location was not allowed: allow it for this site in the browser, or place the point another way.': 'De locatie werd niet toegestaan: sta het toe voor deze site in de browser, of zet de locatie op een andere manier.',
  'The location is not available on this device: place the point another way.': 'De locatie is niet beschikbaar op dit apparaat: zet de locatie op een andere manier.',
  'The location took too long: try again outside, or place the point another way.': 'Het zoeken van de locatie duurde te lang: probeer het buiten opnieuw, of zet de locatie op een andere manier.',
  'Client *': 'Klant *',
  'Choose a client': 'Kies een klant',
  'New client': 'Nieuwe klant',
  'Company name': 'Bedrijfsnaam',
  'Add site': 'Post toevoegen',
};

export default nl;
